<template>
    <v-container fluid>
        <s-crud :filter="filter" :config="config" edit remove @save="save($event)" @EditEvent="editEvent()"
            height="auto" @rowSelected="rowSelected($event)" search-input ref="gridReceptionSurveillance"
            title="Recepcion Vigilancia" :pdf="selected.RcsState == 1" @pdf="downloadGuide()" excel sortable>
            <template v-slot:filter>
                <v-container fluid>
                    <v-row dense justify="start">
                        <v-col cols="6" lg="2" md="4" sm="6">
                            <s-date label="Fecha Inicio" v-model="filter.cDateInitial"></s-date>
                        </v-col>
                        <v-col cols="6" lg="2" md="4" sm="6">
                            <s-date label="Fecha Fin" v-model="filter.cDateFin"></s-date>
                        </v-col>

                        <v-col cols="12" lg="3" md="4" sm="6">
                            <s-select-definition v-model="filter.cDestiny" :def="1175" label="Destino">
                            </s-select-definition>
                        </v-col>

                        <v-col cols="12" lg="2" md="4" sm="6">
                            <s-select-definition :def="1186" label="Estado" :value="2"
                                v-model="filter.cState"></s-select-definition>
                        </v-col>

                        <v-col cols="12" lg="3" md="4" sm="6">
                            <s-select-definition label="Tipo de Servicio" :def="1171"
                                v-model="filter.cTypeServiceID"></s-select-definition>
                        </v-col>

                        <v-col cols="12" lg="3" md="4" sm="6">
                            <s-select-transport full clearable noDefault label="Placa" v-model="filter.TptEnrollment">
                            </s-select-transport>
                        </v-col>

                        <v-col cols="12" lg="3" md="4" sm="6">
                            <s-select-foreman autocomplete full clearable label="Capataz"
                                v-model="filter.FrmID"></s-select-foreman>
                        </v-col>

                        <v-col cols="12" lg="3" md="4" sm="6">
                            <s-select-type-certification clearable noDefault label="Certificacion"
                                v-model="filter.TcrID"></s-select-type-certification>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
              <v-col cols="12" lg="3" md="4">
                <s-text
                  label="Nro. de Programación"
                  v-model="filter.HvsID"
                ></s-text>
              </v-col>
            </v-row> -->
                </v-container>
            </template>

            <template v-slot:ViewCert="{ row }">
                <v-btn x-small color="info" block outlined @click="clickView(row)">
                    <v-icon style="font-size: 16px !important">fas fa-eye</v-icon>
                </v-btn>
            </template>

            <template v-slot:UploadFile="{ row }">
                <v-btn x-small :color="row.HvsAttach ? '#6ad898' : '#b2b2b2'" block outlined
                    @click="clickUploadFile(row)">
                    <v-icon style="font-size: 16px !important">{{
                        row.HvsAttach ? "fas fa-file-alt" : "fas fa-file"
                    }}</v-icon>
                </v-btn>
            </template>

            <template v-slot:Transfer="{ row }">
                <v-btn x-small color="info" block outlined @click="clickTransfer(row)">
                    <v-icon style="font-size: 16px !important">fas fa-truck</v-icon>
                </v-btn>
            </template>

            <template scope="props">
                <alert-supplies :FltID="objLot.FltID"></alert-supplies>

                <!-- Inicio ==> Fundo || Vehiculos || Capataces  -->
                <div class="w-100" :disabled="disabled" v-if="props.item.HvsID !== 0">
                    <!-- Inicio Datos de Programación -->
                    <v-col cols="12" md="12">
                        <v-card>
                            <v-toolbar class="elevation-0" dense dark :color="'#BAB6B5'" style="height: 28px;">
                                <v-toolbar-title style="height: 38px">Datos de Programación</v-toolbar-title>
                            </v-toolbar>
                            <div class="col-12" elevation="0" rounded>
                                <v-row dense class="align-center">
                                    <v-col cols="12" md="6" class="py-1">
                                        <div class="text-body-2 mb-0">Fecha Cosecha Programada: <span
                                                class="font-weight-bold">{{ props.item.RcsDateHarvestSchedule }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" md="3" class="py-1">
                                        <div class="text-body-2 mb-0 font-weight-medium">Planta Procesadora:</div>
                                    </v-col>
                                    <v-col cols="6" md="3" class="py-1">
                                        <s-select-definition :def="1230" v-model="props.item.TypeProcessingPlant" />
                                    </v-col>

                                    <v-col cols="12" md="6" class="py-1">
                                        <div class="text-body-2 mb-0">Nro. Programación: <span
                                                class="font-weight-bold">{{ props.item.HvsID }}</span></div>
                                    </v-col>
                                    <v-col cols="6" md="3" class="py-1" v-if="props.item.TypeProcessingPlant == 2">
                                        <div class="text-body-2 mb-0 font-weight-medium">Empacadora:</div>
                                    </v-col>
                                    <v-col cols="6" md="3" class="py-1" v-if="props.item.TypeProcessingPlant == 2">
                                        <s-select-definition :def="1226" v-model="props.item.TypeBaler" />
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                    </v-col>
                    <!-- Fin Datos de Programación -->

                    <!-- Inicio Fundo/User -->
                    <v-col cols="12" md="12">
                        <v-card>
                            <v-toolbar class="elevation-0" dense dark :color="'#BAB6B5'" style="height: 28px;">
                                <v-toolbar-title style="height: 38px">Datos de Fundo
                                </v-toolbar-title>
                            </v-toolbar>

                            <div class="col-12" elevation="0" rounded>
                                <v-row>
                                    <v-col lg="2" md="2" cols="12">
                                        <s-search-lot-by-cod-senasa @searchSenasa="searchSenasa($event)" />
                                    </v-col>
                                    <v-col cols="12" lg="4" md="4">
                                        <s-text label="Productor" v-model="objLot.PrdText" readonly></s-text>
                                    </v-col>

                                    <v-col cols="12" lg="4" md="4">
                                        <s-text readonly label="Fundo" v-model="objLot.FagName"></s-text>
                                    </v-col>

                                    <v-col cols="12" lg="2" md="2">
                                        <s-text readonly label="Lote" v-model="objLot.FltName"></s-text>
                                    </v-col>

                                    <v-col cols="6" md="2" style="margin-top: -15px">
                                        <s-select-definition label="Tipo de Servicio" :def="1171"
                                            v-model="props.item.TypeService" />
                                    </v-col>

                                    <v-col cols="6" md="2" style="margin-top: -15px">
                                        <s-select-definition :def="1174" label="Procedencia"
                                            v-model="props.item.TypeOrigin" />
                                    </v-col>

                                    <v-col cols="6" md="2" style="margin-top: -15px">
                                        <s-select-definition :def="1172" label="Tipo Cultivo"
                                            v-model="objLot.TypeCrop" />
                                    </v-col>

                                    <v-col cols="6" md="2" style="margin-top: -15px">
                                        <s-select-definition :def="1173" label="Cultivo" v-model="objLot.TypeCultive"
                                            readonly />
                                    </v-col>

                                    <v-col cols="6" md="2" style="margin-top: -15px">
                                        <s-select-variety :cultiveID="objLot.TypeCultive" label="Variedad" full
                                            :text="props.item.VrtName" :value="objLot.VrtID" v-model="objLot.VrtID"
                                            readonly />
                                    </v-col>

                                    <v-col cols="6" md="2" style="margin-top: -15px">
                                        <s-select-definition label="Tipo de Negociacion:" :def="1610"
                                            v-model="objLot.TypeNegociation" readonly></s-select-definition>
                                    </v-col>

                                    <v-col cols="12" md="4" style="margin-top: -15px">
                                        <s-text v-model="objLot.FltCodSenasa" label="Cod. Senasa" readonly />
                                    </v-col>

                                    <v-col cols="12" md="4" style="margin-top: -15px">
                                        <s-text v-model="props.item.TypeDestinyName" label="Destino" readonly />
                                    </v-col>

                                    <v-col cols="12" md="4" style="margin-top: -15px">
                                        <s-text v-model="props.item.RcsDateReception" label="Fecha Recepcion"
                                            readonly />
                                    </v-col>

                                    <v-col cols="12" md="4" style="margin-top: -15px">
                                        <v-text-field label="Direccion: " v-model="objLot.FagAddress"
                                            readonly></v-text-field>
                                    </v-col>

                                    <v-col cols="6" md="4" style="margin-top: -15px">
                                        <v-text-field label="Zona: " v-model="objLot.ZonIDText" readonly></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="4" style="margin-top: -15px">
                                        <v-text-field label="Sub Zona: " v-model="objLot.SzoIDText"
                                            readonly></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                    </v-col>
                    <!-- Fin Fundo/User -->

                    <!-- Inicio Vehicle Fruta-->
                    <v-col cols="12" md="12">
                        <v-card>
                            <v-toolbar class="elevation-0" dense dark :color="'#BAB6B5'" style="height: 28px;">
                                <v-toolbar-title style="height: 38px">Datos de Vehiculo - Fruta</v-toolbar-title>
                            </v-toolbar>

                            <div class="col-12" elevation="0" rounded>
                                <v-data-table item-key="TptId" dense :items="itemsVehicle" :headers="headersVehicle"
                                    v-model="selectedVehicle" :items-per-page="-1" @click:row="rowClickVehicle"
                                    hide-default-footer>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.TptEnrollment="props">
                                        <div class="py-2">
                                            <s-select-transport :value="props.item.TptEnrollment" full
                                                v-model="props.item.TptEnrollment">
                                            </s-select-transport>
                                        </div>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.TptDriver="props">
                                        <s-select-driver clearable full :value="props.item.TptDriver"
                                            v-model="props.item.TptDriver">
                                        </s-select-driver>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.TypeLoadName="props">
                                        <s-select-definition :def="1229" v-model="props.item.TypeLoad" disabled />
                                    </template>


                                    <!-- <template v-slot:item.TptNumberReferralGuide="props">
                                        <s-text v-if="props.item.TypeLoad == 2"
                                            v-model="props.item.TptNumberReferralGuide"
                                            :mask="maskFormatGuideRemission" />
                                    </template>
                                    <template v-slot:item.TptFrmName="props">
                                        <s-select-foreman v-if="props.item.TypeLoad == 2" clearable full
                                            :value="props.item.TptFrmID"
                                            v-model="props.item.TptFrmID"></s-select-foreman>
                                    </template> -->
                                </v-data-table>
                            </div>
                        </v-card>
                    </v-col>
                    <!-- Fin Vehicle -->

                    <!-- Inicio Vehicle Materiales-->
                    <!-- <div cols="12" class="col-md-12" style="margin-top: -20px">
                        <v-col cols="12" md="12">
                            <v-toolbar dense dark :color="'#BAB6B5'">
                                <v-toolbar-title style="height: 38px">Datos de Vehiculo - Materiales</v-toolbar-title>
                            </v-toolbar>

                            <v-row>
                                <v-col cols="12" md="12" style="margin-top: 0px">
                                    <v-data-table item-key="TptId" dense :items="itemsVehicle" :headers="headersVehicle"
                                        v-model="selectedVehicle" :items-per-page="-1" @click:row="rowClickVehicle"
                                        hide-default-footer>
                                        <template v-slot:item.TptEnrollment="props">
                                            <s-select-transport :value="props.item.TptEnrollment" full
                                                v-model="props.item.TptEnrollment">
                                            </s-select-transport>
                                        </template>

                                        <template v-slot:item.TptDriver="props">
                                            <s-select-driver clearable full :value="props.item.TptDriver"
                                                v-model="props.item.TptDriver">
                                            </s-select-driver>
                                        </template>

                                        <template v-slot:item.TypeLoadName="props">
                                            <s-select-definition :def="1229" v-model="props.item.TypeLoad" />
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-col>
                    </div> -->
                    <!-- Fin Vehicle -->

                    <!-- Inicio Certificaciones -->
                    <v-col cols="12">
                        <s-certification-lot :noClose="false" noFooter :height="'auto'" :FltID="objLot.FltID" />
                    </v-col>

                    <!-- Inicio Capataz Programados -->
                    <v-col cols="12">
                        <v-card>
                            <v-toolbar class="elevation-0" dense dark :color="'#BAB6B5'" style="height: 28px;">
                                <v-toolbar-title style="height: 38px">Capataz Programados</v-toolbar-title>
                            </v-toolbar>

                            <!-- <v-row>
                                <v-col cols="6" v-if="selectedGang.length > 0">
                                    <s-select-transport clearable full v-model="selectedGang[0].VehPlate" label="Placa">
                                    </s-select-transport>
                                </v-col>
                                <v-col cols="6" v-if="selectedGang.length > 0">
                                    <s-select-driver label="Chofer" clearable full
                                        v-model="selectedGang[0].DriverName" />
                                </v-col>
                                <v-col cols="3" lg="3" class="s-col-form" v-if="objTransport">
                                    <s-select-farm @dblclick="dblclickTraspot($event)" :typeCharge="1" Quantity="0"
                                        :label="'Chofer - Materiales'" />
                                </v-col>
                                <v-col cols="6" lg="6" class="s-col-form" v-if="objTransport">
                                    <s-text label="Conductor - Materiales"
                                        :value="objTransport.VehPlate + ' ' + objTransport.Driver" readonly />
                                </v-col>
                                <span>
                                    <v-btn elevation="0" class="mt-4" color="error" fab x-small v-if="objTransport"
                                        @click="deleteTransportCap()">X</v-btn>
                                </span>
                            </v-row> -->

                            <div class="col-12" elevation="0" rounded>
                                <v-data-table item-key="GngID" dense :items="itemsGang" :headers="headersGang"
                                    v-model="selectedGang" :items-per-page="-1" @click:row="rowClickGang"
                                    hide-default-footer class="elevation-1 scroll">
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.FrmQuantityReal="props">
                                        <s-text v-model="props.item.FrmQuantityReal" number :min="0"
                                            :disabled="disabled"></s-text>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.FrmQuantityHarvester="props">
                                        <div class="d-flex align-center justify-center py-1">
                                            <s-text v-model="props.item.FrmQuantityHarvester" number
                                                :disabled="disabled"></s-text>
                                            <v-btn x-small color="primary" @click.stop="openHarvestersModal(props.item)"
                                                title="VER COSECHADORES" class="rounded ml-2">
                                                <v-icon x-small>mdi-account-multiple</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.FrmName="props">
                                        <s-select-foreman clearable full :value="props.item.FrmID"
                                            v-model="props.item.FrmID" :disabled="disabled"></s-select-foreman>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.FltName="props">
                                        <s-select-lot v-if="objLot.FltID" :fkFltID="objLot.FltID" :PrdID="objLot.PrdID"
                                            v-model="props.item.FltID" clearable full :disabled="disabled" />
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.VehPlate="props">
                                        <s-select-transport clearable :value="props.item.VehPlate" full
                                            v-model="props.item.VehPlate" :disabled="disabled">
                                        </s-select-transport>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.DriverName="props">
                                        <s-select-driver clearable full :value="props.item.DriverName"
                                            v-model="props.item.DriverName" :disabled="disabled">
                                        </s-select-driver>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.TasGngNumberGuideRemitente="props">
                                        <s-text v-if="props.item.VehPlate && props.item.VehPlate.length > 0"
                                            v-model="props.item.TasGngNumberGuideRemitente"
                                            :mask="maskFormatGuideRemission" :disabled="true">
                                        </s-text>
                                    </template>
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                    <template v-slot:item.TasGngNumberGuideMaterials="props">
                                        <s-text v-if="props.item.VehPlate && props.item.VehPlate.length > 0"
                                            v-model="props.item.TasGngNumberGuideMaterials"
                                            :mask="maskFormatGuideRemission">
                                        </s-text>
                                    </template>

                                    <template v-slot:item.TasGngGuideTransport="props">
                                        <s-text v-if="props.item.VehPlate && props.item.VehPlate.length > 0"
                                            v-model="props.item.TasGngGuideTransport" :mask="maskFormatGuideRemission"
                                            :disabled="false">
                                        </s-text>
                                    </template>
                                    <template v-slot:item.TasGngGuideTransportMaterials="props">
                                        <s-text v-if="props.item.VehPlate && props.item.VehPlate.length > 0"
                                            v-model="props.item.TasGngGuideTransportMaterials"
                                            :mask="maskFormatGuideRemission" :disabled="false">
                                        </s-text>
                                    </template>

                                    <template v-slot:item.VehPlateSecondary="props">
                                        <s-select-transport clearable :value="props.item.VehPlateSecondary" full
                                            v-model="props.item.VehPlateSecondary" :disabled="disabled">
                                        </s-select-transport>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-card>
                    </v-col>
                    <!-- Fin ==> Fundo || Vehiculos || Capataces  -->
                </div>


                <!--Inicio Documentos-->
                <v-col cols="12" md="12">
                    <v-card>
                        <v-toolbar class="elevation-0" dense dark :color="'#BAB6B5'" style="height: 28px;">
                            <v-toolbar-title style="height: 38px">Documentos
                                <span class="font-black text-body-2 ml-4 font-weight-bold" style="color:red">
                                    Campos Obligatorios (*)
                                </span>
                            </v-toolbar-title>
                        </v-toolbar>
                        <div class="col-12" elevation="0" rounded>
                            <v-row dense>
                                <v-col cols="6" md="3" lg="3">
                                    <s-text label="Nro. Guia de Cosecha" type="text"
                                        v-model="props.item.RcsNumberHarvestGuide" :mask="maskFormatGuideHarvested"
                                        :min="3">
                                        <template v-slot:append>
                                            <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                                        </template>
                                    </s-text>
                                </v-col>

                                <v-col cols="6" md="3" lg="2">
                                    <s-text label="Guia Remision Fruta" type="text"
                                        v-model="props.item.RcsNumberReferralGuide" :mask="maskFormatGuideRemission"
                                        @input="changeGuideRemission($event)">
                                        <template v-slot:append>
                                            <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                                        </template>
                                    </s-text>
                                </v-col>

                                <v-col cols="6" md="3" lg="2">
                                    <s-text label="Precinto Sunshine" type="text" v-model="props.item.RcsSunshineSeal">
                                        <template v-slot:append>
                                            <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                                        </template>
                                    </s-text>
                                </v-col>

                                <v-col cols="6" md="3" lg="2">
                                    <s-text label="Precinto Senasa" type="text" v-model="props.item.RcsSenasaSeal" />
                                </v-col>

                                <!-- <v-col cols="6" md="3" lg="3">
                                    <s-select label="Zona Cosecha" :items="ZonesGroup" autocomplete item-text="ZonName"
                                        item-value="ZonID" v-model="RcsPaymentZone" @change="changeZonePayment" />
                                </v-col> -->

                                <!-- <v-col cols="6" md="3">
                                        <s-text label="Guía de Remisión Transportista-Fruta" type="text"
                                            v-model="props.item.RcsNumberFerralGuideDriver">
                                            <template v-slot:append>
                                                <i style="color: red; font-size: 9px" class="fa fa-asterisk"></i>
                                            </template>
                                        </s-text>
                                    </v-col> -->

                                <!-- <v-col cols="6" md="3">
                                        <s-text label="Nro. Guia de Remision Materiales" type="text"
                                            v-model="props.item.RcsNumberFerralGuideMaterials"
                                            :mask="'A###-###############'" />
                                    </v-col>

                                    <v-col cols="12" lg="3" md="3">
                                        <s-text label="Guía de Remisión Transportista-Materiales" type="text"
                                            v-model="props.item.RcsNumberFerralGuideDriverMaterials" />
                                    </v-col> -->

                                <v-col cols="12" md="12">
                                    <s-textarea v-model="props.item.RcsObservations" :rows="3" auto-grow
                                        label="Observaciones"></s-textarea>
                                </v-col>

                                <v-col cols="12" md="12" v-if="uniquePlates.length === 0">
                                    <v-alert dense outlined type="info" class="mb-0 text-caption">
                                        Agregue al menos un capataz con placa asignada para subir la documentación.
                                    </v-alert>
                                </v-col>

                                <v-col cols="12" md="12" v-for="(plate, index) in uniquePlates" :key="index"
                                    class="mb-2">
                                    <v-card outlined class="pa-2 rounded-xl">
                                        <div class="d-flex align-center mb-2 ml-1">
                                            <v-icon small color="primary" class="mr-2">mdi-truck</v-icon>
                                            <span class="font-weight-bold"
                                                style="color: #1e293b; font-size: 0.85rem; text-transform: uppercase;">DOCUMENTOS
                                                -
                                                PLACA: {{ plate }} <span style="color: #0288d1; font-weight: bold;">{{
                                                    getPlateSummary(plate) }}</span></span>
                                        </div>
                                        <v-row dense>
                                            <!-- COLUMNA FRUTA -->
                                            <v-col cols="12" md="6" class="pa-1">
                                                <div class="group-wrapper green lighten-5">
                                                    <div class="group-header d-flex align-center mb-2">
                                                        <v-icon small color="blue-grey darken-2" class="mr-2">
                                                            mdi-fruit-grapes
                                                        </v-icon>
                                                        GUÍA REMISIÓN TRANSPORTISTA: FRUTA
                                                    </div>
                                                    <v-row dense>
                                                        <v-col cols="6">
                                                            <v-hover v-slot="{ hover }">
                                                                <v-card outlined class="premium-file-card"
                                                                    :class="{ 'active': AttachPDF[plate] || getExistingPath(plate, 'TasPathGngGuideTransportPdf'), 'elevation-2': hover }"
                                                                    @click="!AttachPDF[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportPdf') && $refs.fileInputPDF[index].click()">
                                                                    <div class="d-flex align-center pa-1 w-100">
                                                                        <div class="file-icon-container mr-1"
                                                                            :class="{ 'pdf-active': AttachPDF[plate] || getExistingPath(plate, 'TasPathGngGuideTransportPdf') }">
                                                                            <v-icon size="20"
                                                                                :color="AttachPDF[plate] || getExistingPath(plate, 'TasPathGngGuideTransportPdf') ? 'white' : '#757575'">
                                                                                {{ (AttachPDF[plate] ||
                                                                                    getExistingPath(plate,
                                                                                        'TasPathGngGuideTransportPdf')) ?
                                                                                    'mdi-file-check' :
                                                                                    'mdi-file-pdf-box'
                                                                                }}
                                                                            </v-icon>
                                                                        </div>
                                                                        <div class="flex-grow-1" style="min-width: 0">
                                                                            <div class="text-overline mb-0 truncate"
                                                                                style="color: #d32f2f; font-weight: 800; line-height: 1.2; font-size: 0.6rem !important;">
                                                                                PDF
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-if="AttachPDF[plate]">
                                                                                {{ AttachPDF[plate].name }}
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-else-if="getExistingPath(plate, 'TasPathGngGuideTransportPdf')">
                                                                                {{ getExistingPath(plate,
                                                                                    'TasPathGngGuideTransportPdf') }}
                                                                            </div>
                                                                            <div class="file-placeholder" v-else>
                                                                                Seleccionar PDF...
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex align-center pr-1">
                                                                            <v-fade-transition>
                                                                                <div v-if="AttachPDF[plate] || getExistingPath(plate, 'TasPathGngGuideTransportPdf')"
                                                                                    class="d-flex">
                                                                                    <v-btn
                                                                                        v-if="getExistingPath(plate, 'TasPathGngGuideTransportPdf') && !AttachPDF[plate]"
                                                                                        icon color="primary"
                                                                                        class="mr-0"
                                                                                        @click.stop="downloadFileGRE(getExistingPath(plate, 'TasPathGngGuideTransportPdf'))">
                                                                                        <v-icon
                                                                                            size="16">mdi-download-circle</v-icon>
                                                                                    </v-btn>
                                                                                    <v-btn icon color="error"
                                                                                        @click.stop="clearPDF(plate, index)">
                                                                                        <v-icon
                                                                                            size="16">mdi-close-circle</v-icon>
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-fade-transition>
                                                                            <v-btn
                                                                                v-if="!AttachPDF[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportPdf')"
                                                                                icon color="grey darken-1"
                                                                                @click.stop="$refs.fileInputPDF[index].click()">
                                                                                <v-icon
                                                                                    size="18">mdi-cloud-upload</v-icon>
                                                                            </v-btn>
                                                                        </div>
                                                                    </div>
                                                                    <input type="file" ref="fileInputPDF" v-show="false"
                                                                        accept="application/pdf"
                                                                        @change="onPDFChange($event, plate)" />
                                                                </v-card>
                                                            </v-hover>
                                                        </v-col>

                                                        <v-col cols="6">
                                                            <v-hover v-slot="{ hover }">
                                                                <v-card outlined class="premium-file-card"
                                                                    :class="{ 'active-xml': AttachXML[plate] || getExistingPath(plate, 'TasPathGngGuideTransportXml'), 'elevation-2': hover }"
                                                                    @click="!AttachXML[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportXml') && $refs.fileInputXML[index].click()">
                                                                    <div class="d-flex align-center pa-1 w-100">
                                                                        <div class="file-icon-container mr-1"
                                                                            :class="{ 'xml-active': AttachXML[plate] || getExistingPath(plate, 'TasPathGngGuideTransportXml') }">
                                                                            <v-icon size="20"
                                                                                :color="AttachXML[plate] || getExistingPath(plate, 'TasPathGngGuideTransportXml') ? 'white' : '#757575'">
                                                                                {{
                                                                                    (AttachXML[plate] ||
                                                                                        getExistingPath(plate,
                                                                                            'TasPathGngGuideTransportXml')) ?
                                                                                        'mdi-file-code' :
                                                                                        'mdi-xml' }}
                                                                            </v-icon>
                                                                        </div>
                                                                        <div class="flex-grow-1" style="min-width: 0">
                                                                            <div class="text-overline mb-0 truncate"
                                                                                style="color: #2e7d32; font-weight: 800; line-height: 1.2; font-size: 0.6rem !important;">
                                                                                XML
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-if="AttachXML[plate]">
                                                                                {{ AttachXML[plate].name }}
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-else-if="getExistingPath(plate, 'TasPathGngGuideTransportXml')">
                                                                                {{ getExistingPath(plate,
                                                                                    'TasPathGngGuideTransportXml') }}
                                                                            </div>
                                                                            <div class="file-placeholder" v-else>
                                                                                Seleccionar XML...
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex align-center pr-1">
                                                                            <v-fade-transition>
                                                                                <div v-if="AttachXML[plate] || getExistingPath(plate, 'TasPathGngGuideTransportXml')"
                                                                                    class="d-flex">
                                                                                    <v-btn
                                                                                        v-if="getExistingPath(plate, 'TasPathGngGuideTransportXml') && !AttachXML[plate]"
                                                                                        icon color="primary"
                                                                                        class="mr-0"
                                                                                        @click.stop="downloadFileGRE(getExistingPath(plate, 'TasPathGngGuideTransportXml'))">
                                                                                        <v-icon
                                                                                            size="16">mdi-download-circle</v-icon>
                                                                                    </v-btn>
                                                                                    <v-btn icon color="error"
                                                                                        @click.stop="clearXML(plate, index)">
                                                                                        <v-icon
                                                                                            size="16">mdi-close-circle</v-icon>
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-fade-transition>
                                                                            <v-btn
                                                                                v-if="!AttachXML[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportXml')"
                                                                                icon color="grey darken-1"
                                                                                @click.stop="$refs.fileInputXML[index].click()">
                                                                                <v-icon
                                                                                    size="18">mdi-cloud-upload</v-icon>
                                                                            </v-btn>
                                                                        </div>
                                                                    </div>
                                                                    <input type="file" ref="fileInputXML" v-show="false"
                                                                        accept="text/xml,application/xml"
                                                                        @change="onXMLChange($event, plate)" />
                                                                </v-card>
                                                            </v-hover>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-col>

                                            <!-- COLUMNA MATERIALES -->
                                            <v-col cols="12" md="6" class="pa-1">
                                                <div class="group-wrapper materiales orange lighten-5">
                                                    <div class="group-header d-flex align-center mb-2">
                                                        <v-icon small color="blue-grey darken-1"
                                                            class="mr-2">mdi-package-variant</v-icon>
                                                        GUÍA REMISIÓN TRANSPORTISTA: MATERIALES
                                                    </div>
                                                    <v-row dense>
                                                        <v-col cols="6">
                                                            <v-hover v-slot="{ hover }">
                                                                <v-card outlined class="premium-file-card"
                                                                    :class="{ 'active': AttachPDFMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf'), 'elevation-2': hover }"
                                                                    @click="!AttachPDFMaterials[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf') && $refs.fileInputPDFMaterials[index].click()">
                                                                    <div class="d-flex align-center pa-1 w-100">
                                                                        <div class="file-icon-container mr-1"
                                                                            :class="{ 'pdf-active': AttachPDFMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf') }">
                                                                            <v-icon size="20"
                                                                                :color="AttachPDFMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf') ? 'white' : '#757575'">
                                                                                {{ (AttachPDFMaterials[plate] ||
                                                                                    getExistingPath(plate,
                                                                                        'TasPathGngGuideTransportMaterialsPdf'))
                                                                                    ?
                                                                                    'mdi-file-check' :
                                                                                    'mdi-file-pdf-box'
                                                                                }}
                                                                            </v-icon>
                                                                        </div>
                                                                        <div class="flex-grow-1" style="min-width: 0">
                                                                            <div class="text-overline mb-0 truncate"
                                                                                style="color: #d32f2f; font-weight: 800; line-height: 1.2; font-size: 0.6rem !important;">
                                                                                PDF
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-if="AttachPDFMaterials[plate]">
                                                                                {{ AttachPDFMaterials[plate].name }}
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-else-if="getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf')">
                                                                                {{ getExistingPath(plate,
                                                                                    'TasPathGngGuideTransportMaterialsPdf')
                                                                                }}
                                                                            </div>
                                                                            <div class="file-placeholder" v-else>
                                                                                Seleccionar PDF...
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex align-center pr-1">
                                                                            <v-fade-transition>
                                                                                <div v-if="AttachPDFMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf')"
                                                                                    class="d-flex">
                                                                                    <v-btn
                                                                                        v-if="getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf') && !AttachPDFMaterials[plate]"
                                                                                        icon color="primary"
                                                                                        class="mr-0"
                                                                                        @click.stop="downloadFileGRE(getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf'))">
                                                                                        <v-icon
                                                                                            size="16">mdi-download-circle</v-icon>
                                                                                    </v-btn>
                                                                                    <v-btn icon color="error"
                                                                                        @click.stop="clearPDFMaterials(plate, index)">
                                                                                        <v-icon
                                                                                            size="16">mdi-close-circle</v-icon>
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-fade-transition>
                                                                            <v-btn
                                                                                v-if="!AttachPDFMaterials[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf')"
                                                                                icon color="grey darken-1"
                                                                                @click.stop="$refs.fileInputPDFMaterials[index].click()">
                                                                                <v-icon
                                                                                    size="18">mdi-cloud-upload</v-icon>
                                                                            </v-btn>
                                                                        </div>
                                                                    </div>
                                                                    <input type="file" ref="fileInputPDFMaterials"
                                                                        v-show="false" accept="application/pdf"
                                                                        @change="onPDFMaterialsChange($event, plate)" />
                                                                </v-card>
                                                            </v-hover>
                                                        </v-col>

                                                        <v-col cols="6">
                                                            <v-hover v-slot="{ hover }">
                                                                <v-card outlined class="premium-file-card"
                                                                    :class="{ 'active-xml': AttachXMLMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml'), 'elevation-2': hover }"
                                                                    @click="!AttachXMLMaterials[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml') && $refs.fileInputXMLMaterials[index].click()">
                                                                    <div class="d-flex align-center pa-1 w-100">
                                                                        <div class="file-icon-container mr-1"
                                                                            :class="{ 'xml-active': AttachXMLMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml') }">
                                                                            <v-icon
                                                                                :color="AttachXMLMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml') ? 'white' : '#757575'"
                                                                                size="20">
                                                                                {{
                                                                                    (AttachXMLMaterials[plate] ||
                                                                                        getExistingPath(plate,
                                                                                            'TasPathGngGuideTransportMaterialsXml'))
                                                                                        ?
                                                                                        'mdi-file-code' : 'mdi-xml'
                                                                                }}
                                                                            </v-icon>
                                                                        </div>
                                                                        <div class="flex-grow-1" style="min-width: 0">
                                                                            <div class="text-overline mb-0 truncate"
                                                                                style="color: #2e7d32; font-weight: 800; line-height: 1.2; font-size: 0.6rem !important;">
                                                                                XML
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-if="AttachXMLMaterials[plate]">
                                                                                {{ AttachXMLMaterials[plate].name }}
                                                                            </div>
                                                                            <div class="file-name text-truncate"
                                                                                v-else-if="getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml')">
                                                                                {{ getExistingPath(plate,
                                                                                    'TasPathGngGuideTransportMaterialsXml')
                                                                                }}
                                                                            </div>
                                                                            <div class="file-placeholder" v-else>
                                                                                Seleccionar XML...
                                                                            </div>
                                                                        </div>
                                                                        <div class="d-flex align-center pr-1">
                                                                            <v-fade-transition>
                                                                                <div v-if="AttachXMLMaterials[plate] || getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml')"
                                                                                    class="d-flex">
                                                                                    <v-btn
                                                                                        v-if="getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml') && !AttachXMLMaterials[plate]"
                                                                                        icon color="primary"
                                                                                        class="mr-0"
                                                                                        @click.stop="downloadFileGRE(getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml'))">
                                                                                        <v-icon
                                                                                            size="16">mdi-download-circle</v-icon>
                                                                                    </v-btn>
                                                                                    <v-btn icon color="error"
                                                                                        @click.stop="clearXMLMaterials(plate, index)">
                                                                                        <v-icon
                                                                                            size="16">mdi-close-circle</v-icon>
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-fade-transition>
                                                                            <v-btn
                                                                                v-if="!AttachXMLMaterials[plate] && !getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml')"
                                                                                icon color="grey darken-1"
                                                                                @click.stop="$refs.fileInputXMLMaterials[index].click()">
                                                                                <v-icon
                                                                                    size="18">mdi-cloud-upload</v-icon>
                                                                            </v-btn>
                                                                        </div>
                                                                    </div>
                                                                    <input type="file" ref="fileInputXMLMaterials"
                                                                        v-show="false" accept="text/xml,application/xml"
                                                                        @change="onXMLMaterialsChange($event, plate)" />
                                                                </v-card>
                                                            </v-hover>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row dense
                                            v-if="XMLSummary[plate] && (XMLSummary[plate].fruta || XMLSummary[plate].materiales)"
                                            class="mt-2">
                                            <!-- Resumen Fruta -->
                                            <v-col cols="12" md="6" class="pa-1">
                                                <v-card
                                                    v-if="AttachXML[plate] && XMLSummary[plate] && XMLSummary[plate].fruta"
                                                    :color="XMLSummary[plate].fruta.isValid ? '#e8f5e9' : '#ffebee'"
                                                    outlined class="pa-2 rounded-lg" style="border: 1px solid"
                                                    :style="{ borderColor: XMLSummary[plate].fruta.isValid ? '#4caf50' : '#f44336' }">
                                                    <div class="d-flex align-center">
                                                        <v-icon size="32"
                                                            :color="XMLSummary[plate].fruta.isValid ? 'success' : 'error'"
                                                            class="mr-3">
                                                            {{ XMLSummary[plate].fruta.isValid ? 'mdi-check-circle' :
                                                                'mdi-alert-circle'
                                                            }}
                                                        </v-icon>
                                                        <div
                                                            style="font-size: 0.72rem; color: #424242; line-height: 1.2;">
                                                            <div>
                                                                <strong>Nro. Guía:</strong>
                                                                {{ XMLSummary[plate].fruta.nroGuia || 'No encontrado' }}
                                                            </div>
                                                            <div>
                                                                <strong>Guía Remisión Remitente:</strong>
                                                                {{ XMLSummary[plate].fruta.guiaRemitente
                                                                    || 'No encontrado'
                                                                }}
                                                            </div>
                                                            <div>
                                                                <strong>Placa Extraída:</strong>
                                                                {{ XMLSummary[plate].fruta.placa || 'No encontrado' }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-card>
                                            </v-col>

                                            <!-- Resumen Materiales -->
                                            <v-col cols="12" md="6" class="pa-1">
                                                <v-card
                                                    v-if="AttachXMLMaterials[plate] && XMLSummary[plate] && XMLSummary[plate].materiales"
                                                    :color="XMLSummary[plate].materiales.isValid ? '#e8f5e9' : '#ffebee'"
                                                    outlined class="pa-2 rounded-lg" style="border: 1px solid"
                                                    :style="{ borderColor: XMLSummary[plate].materiales.isValid ? '#4caf50' : '#f44336' }">
                                                    <div class="d-flex align-center">
                                                        <v-icon size="32"
                                                            :color="XMLSummary[plate].materiales.isValid ? 'success' : 'error'"
                                                            class="mr-3">
                                                            {{ XMLSummary[plate].materiales.isValid ? 'mdi-check-circle'
                                                                :
                                                                'mdi-alert-circle' }}
                                                        </v-icon>
                                                        <div
                                                            style="font-size: 0.72rem; color: #424242; line-height: 1.2;">
                                                            <div>
                                                                <strong>Nro. Guía:</strong>
                                                                {{
                                                                    XMLSummary[plate].materiales.nroGuia ||
                                                                    'No encontrado'
                                                                }}
                                                            </div>
                                                            <div>
                                                                <strong>Guía Remisión Remitente:</strong>
                                                                {{
                                                                    XMLSummary[plate].materiales.guiaRemitente
                                                                    || 'No encontrado'
                                                                }}
                                                            </div>
                                                            <div>
                                                                <strong>Placa Extraída:</strong>
                                                                {{ XMLSummary[plate].materiales.placa || 'No encontrado'
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>

                                <!-- Sección para Cargar Codigo QR decoficar su texto contenido del QR removida de aquí -->
                            </v-row>
                        </div>
                    </v-card>
                </v-col>
                <!--Fin Documentos-->
            </template>
        </s-crud>

        <v-dialog v-if="dialogGuidePdf" v-model="dialogGuidePdf" fullscreen persistent>
            <guide-pdf :referralGuideSelected="dataPdf" @close="dialogGuidePdf = false"></guide-pdf>
        </v-dialog>

        <v-dialog v-if="openDialogView" v-model="openDialogView" persistent style="display: contents" width="70%">
            <s-certification-lot :FltID="FltID" @close="close()" />
        </v-dialog>

        <v-dialog v-if="openDialogUploadFile" v-model="openDialogUploadFile" persistent max-width="700px">
            <v-card class="rounded-xl overflow-hidden pa-0 elevation-10">
                <AlertSunshine :dialog="loadingCalculate" :text="textLoading" />
                <!-- Header -->
                <div class="modern-header d-flex justify-space-between align-center py-3 px-4"
                    style="background: linear-gradient(135deg, #1e293b 0%, #334155 100%);">
                    <div class="d-flex align-center">
                        <v-icon color="white" class="mr-2" size="24">mdi-qrcode-scan</v-icon>
                        <span class="font-weight-bold text-subtitle-1 white--text">
                            SUBIR ADJUNTO - LECTOR QR
                        </span>
                    </div>
                    <v-btn icon dark small @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-card-text class="pa-4">
                    <!-- Error alert -->
                    <v-alert v-if="qrError" dense outlined type="error" class="mb-4 rounded-lg text-caption" dismissible
                        @input="qrError = ''">
                        {{ qrError }}
                    </v-alert>

                    <!-- State 1: No file selected -->
                    <div v-if="!Attach"
                        class="qr-dropzone d-flex flex-column align-center justify-center pa-6 rounded-xl cursor-pointer"
                        :class="{ 'drag-over': qrDragOver }" @dragover.prevent="qrDragOver = true"
                        @dragleave.prevent="qrDragOver = false" @drop.prevent="onQrFileDrop" @click="triggerQrFileInput"
                        style="height: 250px; border: 2px dashed #cfd8dc; background-color: #f8fafc;">
                        <v-icon size="48" :color="qrDragOver ? 'primary' : 'grey darken-1'" class="mb-3 animate-pulse">
                            mdi-cloud-upload-outline
                        </v-icon>
                        <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-1">
                            Arrastra tu imagen QR aquí
                        </div>
                        <div class="text-caption grey--text text--darken-1 mb-3">
                            O haz clic para explorar en tu dispositivo
                        </div>
                        <v-chip x-small color="primary" outlined class="text-overline">
                            PNG, JPG, JPEG, WEBP
                        </v-chip>
                    </div>

                    <!-- State 2: Existing file (not a File instance, just has a name) -->
                    <div v-else-if="Attach && !Attach.type"
                        class="d-flex flex-column align-center justify-center pa-6 rounded-xl grey lighten-4 border"
                        style="min-height: 250px;">
                        <v-row dense class="w-100 fill-height align-center">
                            <!-- Image Preview if available -->
                            <v-col cols="12" md="6"
                                class="pa-2 text-center d-flex flex-column align-center justify-center"
                                v-if="retrievedImagePreview">
                                <div class="qr-preview-container rounded-xl overflow-hidden elevation-2"
                                    style="height: 180px; width: 100%; max-width: 220px; background-color: white;">
                                    <v-img :src="retrievedImagePreview" max-height="180" contain></v-img>
                                </div>
                            </v-col>

                            <!-- Actions / Info -->
                            <v-col cols="12" :md="retrievedImagePreview ? 6 : 12"
                                class="pa-2 text-center d-flex flex-column align-center justify-center">
                                <v-icon size="48" color="success" class="mb-2">
                                    mdi-file-check-outline
                                </v-icon>
                                <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-1">
                                    Archivo ya adjuntado
                                </div>
                                <div class="text-caption grey--text text--darken-1 mb-4 text-truncate"
                                    style="max-width: 90%;">
                                    {{ Attach.name }}
                                </div>
                                <div class="d-flex" style="gap: 12px; justify-content: center; width: 100%;">
                                    <v-btn color="success" outlined class="rounded-lg text-none"
                                        @click="openFile(Attach)">
                                        <v-icon left>mdi-download</v-icon>
                                        Descargar
                                    </v-btn>
                                    <v-btn color="error" outlined class="rounded-lg text-none" @click="clearQrScanner">
                                        <v-icon left>mdi-swap-horizontal</v-icon>
                                        Reemplazar
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- State 3: New File Selected (File instance) -->
                    <div v-else class="mt-2">
                        <v-row dense>
                            <!-- Preview -->
                            <v-col cols="12" md="5" class="pa-2 text-center">
                                <div class="qr-preview-container rounded-xl overflow-hidden position-relative elevation-2 cursor-pointer"
                                    style="height: 280px;" @click="triggerQrFileInput">
                                    <v-img :src="qrImagePreview" max-height="280" contain
                                        class="qr-preview-image"></v-img>
                                    <!-- Scanner laser -->
                                    <div class="scanner-laser" v-if="qrDecoding"></div>
                                </div>
                                <div class="mt-3">
                                    <v-btn color="error" class="rounded-lg text-none white--text"
                                        @click.stop="clearQrScanner">
                                        <v-icon left size="16">mdi-delete-outline</v-icon>
                                        Eliminar Imagen
                                    </v-btn>
                                </div>
                            </v-col>

                            <!-- Decoded Content -->
                            <v-col cols="12" md="7" class="pa-2">
                                <div v-if="qrDecodedContent"
                                    class="qr-table-container rounded-xl pa-0 d-flex flex-column justify-center border"
                                    style="min-height: 280px;">
                                    <div class="d-flex align-center justify-space-between mb-2 px-3">
                                        <span
                                            class="text-subtitle-2 font-weight-bold grey--text text--darken-3 d-flex align-center">
                                            <v-icon left color="success" size="18">mdi-check-circle</v-icon>
                                            DATOS DEL QR
                                        </span>
                                    </div>

                                    <div class="qr-table-scroll border rounded-lg overflow-y-auto"
                                        style="max-height: 220px;">
                                        <v-simple-table dense class="qr-data-table">
                                            <template v-slot:default>
                                                <!-- <thead>
                                                    <tr>
                                                        <th class="text-left font-weight-bold text-caption py-1 grey lighten-4"
                                                            style="color: #475569; width: 35%;">CAMPO</th>
                                                        <th class="text-left font-weight-bold text-caption py-1 grey lighten-4"
                                                            style="color: #475569;">VALOR</th>
                                                    </tr>
                                                </thead> -->
                                                <tbody>
                                                    <tr v-for="(item, idx) in parsedQrData" :key="idx">
                                                        <td class="font-weight-medium text-caption py-1"
                                                            style="color: #64748b;">
                                                            <span class="d-inline-block text-truncate"
                                                                style="max-width: 100px;" :title="item.label">
                                                                {{ item.label }}
                                                            </span>
                                                        </td>
                                                        <td class="text-caption font-weight-bold py-1 text-selectable"
                                                            style="color: #1e293b; word-break: break-all;">
                                                            <div class="d-flex align-center flex-wrap"
                                                                style="gap: 4px;">
                                                                <span>{{ item.value }}</span>
                                                                <template v-if="item.validation">
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-chip v-bind="attrs" v-on="on" x-small
                                                                                :color="item.validation.isValid ? 'success' : 'error'"
                                                                                class="white--text px-1 font-weight-bold"
                                                                                label
                                                                                style="font-size: 0.6rem; height: 16px;">
                                                                                <v-icon left size="8"
                                                                                    class="white--text mr-1">
                                                                                    {{ item.validation.isValid ?
                                                                                        'mdi-check-circle' :
                                                                                        'mdi-alert-circle' }}
                                                                                </v-icon>
                                                                                {{ item.validation.isValid ? 'OK' :
                                                                                    'DIFF' }}
                                                                            </v-chip>
                                                                        </template>
                                                                        <span>{{ item.validation.message }}</span>
                                                                    </v-tooltip>
                                                                </template>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </div>
                                </div>

                                <!-- Placeholder when decoding or no data -->
                                <div v-else
                                    class="d-flex flex-column align-center justify-center fill-height pa-6 text-center grey lighten-4 rounded-xl border-dashed"
                                    style="height: 280px;">
                                    <v-icon size="48" color="grey lighten-1" class="mb-2"
                                        :class="{ 'animate-pulse': qrDecoding }">
                                        {{ qrDecoding ? 'mdi-qrcode-scan' : 'mdi-table-large' }}
                                    </v-icon>
                                    <span class="text-caption font-weight-bold grey--text text--darken-2 mb-1">
                                        {{ qrDecoding ? 'Decodificando...' : 'Analizando Código QR' }}
                                    </span>
                                    <span class="text-caption grey--text">
                                        {{ qrDecoding ? 'Espere un momento por favor mientras procesamos el QR.' :
                                            'Cargando imagen...' }}
                                    </span>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Hidden input and qrcode component -->
                    <input type="file" ref="qrFileInput" accept="image/*" style="display: none;"
                        @change="onQrFileSelected" />
                    <qrcode-capture ref="qrCapture" style="display: none;" @decode="onQrDecode" @detect="onQrDetect" />
                </v-card-text>

                <!-- Footer actions -->
                <v-card-actions class="px-4 py-3 grey lighten-4 d-flex justify-end"
                    style="border-top: 1px solid #e2e8f0;">
                    <v-btn color="error" class="text-none rounded-lg" @click="close()">
                        Cancelar
                    </v-btn>
                    <v-btn color="success" class="text-none rounded-lg"
                        :disabled="!Attach || (Attach && !Attach.type) || qrValidationFailed"
                        @click="handleSaveFileClick()">
                        <v-icon left>mdi-cloud-upload</v-icon>
                        Guardar Adjunto
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="processing" v-if="processing" :persistent="messageProcessing.length == 0" width="400">
            <v-card color="primary" dark>
                <v-card-text v-if="messageProcessing.length == 0">
                    Por favor espere
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
                <v-card-text v-else>
                    <div class="text--white pt-4">
                        Error al realizar operacion <br />
                        {{ messageProcessing }}
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-if="dialogTransfer" v-model="dialogTransfer" persistent max-width="800px">
            <v-card class="rounded-xl">
                <div class="modern-header">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-truck</v-icon>
                            <h2 class="header-title" style="text-transform: uppercase; font-size: 1.2rem">
                                Transbordo de Mercancía
                            </h2>
                        </div>
                        <div class="header-actions">
                            <v-btn icon large class="close-btn" @click="dialogTransfer = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <v-container fluid>
                    <template v-if="messageValidation">
                        <div class="d-flex justify-start pb-2">
                            <v-alert colored-border border="left" elevation="2" color="warning"
                                class="rounded-xl mb-0 w-100" style="max-width: 500px">
                                <v-row align="center" no-gutters>
                                    <v-col cols="auto pl-2">
                                        <v-icon style="transform: scale(2.5)" color="warning">mdi-information</v-icon>
                                    </v-col>
                                    <v-col class="grow pl-5">
                                        <p class="text-body-1 font-weight-medium warning--text pa-0 ma-0">
                                            {{ messageValidation }}
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-alert>
                        </div>
                    </template>

                    <!-- Card Layout for Javas Programmed and Real -->
                    <v-row v-if="selected.GetGang" class="mb-2" dense>
                        <v-col cols="12" sm="6">
                            <v-card class="rounded-xl overflow-hidden shadow-premium" outlined elevation="0">
                                <div class="d-flex align-center justify-space-between pa-2"
                                    style="background: linear-gradient(135deg, #1e293b 0%, #334155 100%);color: white;">
                                    <div>
                                        <p class="text-overline mb-0 white--text" style="
                          opacity: 0.8;
                          letter-spacing: 1.2px;
                          font-weight: 600;
                        ">
                                            JAVAS PROGRAMADAS
                                        </p>
                                        <h3 class="text-h3 font-weight-bold white--text">
                                            {{ getSumatoriaJabas("FrmQuantityEstimate") }}
                                        </h3>
                                    </div>
                                    <v-icon size="64" color="white">mdi-clipboard-list-outline</v-icon>
                                </div>
                                <v-divider></v-divider>
                                <div class="px-4 py-2" style="background-color: #f8fafc">
                                    <span class="text-caption font-weight-bold blue-grey--text text--darken-3">
                                        <v-icon x-small color="blue-grey darken-3"
                                            class="mr-1">mdi-information-outline</v-icon>
                                        Total proyectado para recolección
                                    </span>
                                </div>
                            </v-card>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-card class="rounded-xl overflow-hidden shadow-premium" outlined elevation="0">
                                <div class="d-flex align-center justify-space-between pa-2" :style="getSumatoriaJabas() > 0
                                    ? 'background: linear-gradient(135deg, #065f46 0%, #10b981 100%); color: white;'
                                    : 'background: linear-gradient(135deg, #991b1b 0%, #ef4444 100%); color: white;'
                                    ">
                                    <div>
                                        <p class="text-overline mb-0 white--text" style="
                          opacity: 0.8;
                          letter-spacing: 1.2px;
                          font-weight: 600;
                        ">
                                            JAVAS REALES
                                        </p>
                                        <h3 v-if="getSumatoriaJabas() > 0" class="text-h3 font-weight-bold white--text">
                                            {{ getSumatoriaJabas() }}
                                        </h3>
                                        <h3 v-else class="text-h6 font-weight-bold white--text mt-1"
                                            style="line-height: 1.2">
                                            PENDIENTE POR<br />RECEPCIONAR
                                        </h3>
                                    </div>
                                    <v-icon size="64" color="white">
                                        {{
                                            getSumatoriaJabas() > 0
                                                ? "mdi-check-decagram-outline"
                                                : "mdi-clock-alert-outline"
                                        }}
                                    </v-icon>
                                </div>
                                <v-divider />
                                <div class="px-4 py-2" :style="getSumatoriaJabas() > 0
                                    ? 'background-color: #ecfdf5;'
                                    : 'background-color: #fef2f2;'
                                    ">
                                    <span class="text-caption font-weight-bold" :class="getSumatoriaJabas() > 0
                                        ? 'green--text text--darken-4'
                                        : 'red--text text--darken-4'
                                        ">
                                        <v-icon x-small :color="getSumatoriaJabas() > 0
                                            ? 'green darken-4'
                                            : 'red darken-4'
                                            " class="mr-1">
                                            {{
                                                getSumatoriaJabas() > 0
                                                    ? "mdi-check-circle"
                                                    : "mdi-alert"
                                            }}
                                        </v-icon>
                                        {{
                                            getSumatoriaJabas() > 0
                                                ? "Ingreso validado"
                                                : "Esperando registro de javas reales"
                                        }}
                                    </span>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>

                    <s-crud :filter="filterTransfer" :config="configTransfer" add edit remove
                        @addEvent="clearFormTransfer()" @save="saveTransfer($event)" @EditEvent="editTransfer()"
                        height="auto" @rowSelected="rowSelectedTransfer($event)" search-input
                        ref="gridReceptionTransfer" title="Transbordo de Mercancía">
                        <template scope="props">
                            <v-row dense justify="start">
                                <v-col cols="12" sm="3">
                                    <s-select-reception-surveillance-gang label="Capataz" clearable full
                                        :hvs-id="selected.HvsID" :value="formTransfer.FrmID"
                                        v-model="formTransfer.FrmID"></s-select-reception-surveillance-gang>
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <s-select-farm @dblclick="dblclick($event)" v-model="formTransfer.SearchVehPlate"
                                        :typeCharge="1" :Quantity="0" />
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <s-text label="Placa" v-model="formTransfer.VehPlate" disabled readonly></s-text>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <s-text label="Tipo de vehículo" v-model="formTransfer.TypeVehicleName" disabled
                                        readonly></s-text>
                                </v-col>
                                <v-col cols="12" md="6" sm="6">
                                    <s-text label="Nombres del chofer" v-model="formTransfer.TrtDriverName" disabled
                                        readonly></s-text>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <s-text label="Capacidad" v-model="formTransfer.CfvCapacity" disabled
                                        readonly></s-text>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <s-text label="Cantidad Transbordo" v-model="formTransfer.TransferQuantity"
                                        type="number"></s-text>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <s-date label="Fecha Transbordo" v-model="formTransfer.TransferDate"></s-date>
                                </v-col>
                                <v-col cols="12" md="4" sm="7" class="s-col-text">
                                    <v-row dense>
                                        <v-col class="col-10">
                                            <v-file-input label="Documento de Transbordo" v-model="AttachTransfer"
                                                hide-details />
                                        </v-col>
                                        <v-col>
                                            <v-btn color="success" class="mt-5" :disabled="false" icon small
                                                @click="openFileTransfer(AttachTransfer)">
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-slot:ForemanDNI="{ row }">
                            {{ row.ForemanDNI }} - {{ row.ForemanName }}
                        </template>

                        <template v-slot:TrtDriverDNI="{ row }">
                            {{ row.TrtDriverDNI }} - {{ row.TrtDriverName }}
                        </template>

                        <template v-slot:UploadFile="{ row }">
                            <div class="d-flex justify-end pa-1" v-if="row.UploadFile">
                                <v-btn icon small @click="openFileTransfer(row.UploadFile)" color="success">
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </s-crud>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- Modal for viewing harvesters of a capataz -->
        <v-dialog v-model="showHarvestersModal" max-width="600px">
            <v-card class="rounded-xl">
                <div class="modal-header-premium py-3 px-3 d-flex align-center">
                    <div class="header-icon-box mr-2 elevation-3">
                        <v-icon color="white">mdi-account-multiple</v-icon>
                    </div>
                    <h3 class="text-h6 font-weight-black white--text mb-n1 tracking-tight">
                        Cosechadores del Capataz
                    </h3>
                    <v-spacer></v-spacer>
                    <v-btn icon dark small @click="showHarvestersModal = false" class="close-btn-hover">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <div class="pa-0 rounded-xl">
                    <v-data-table :headers="headersHarvestersModal"
                        :items="(currentForemanForModal?.DetailsHarvesters || [])" hide-default-footer dense
                        class="elevation-1 rounded-xl" no-data-text="No hay cosechadores asignados a este capataz."
                        height="auto" fixed-header>
                    </v-data-table>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
//Service
import _sReceptionSurveillance from "../../../services/Technicalassistance/ReceptionSurveillanceService";
import _sReceptionTransfer from "../../../services/Technicalassistance/ReceptionTransferService";
import _sGenParam from "../../../services/General/ParameterService";
import _GenUploadFiles from "../../../services/General/GenUploadFiles";

//Component
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectLot from "@/components/HarvestSchedule/SSelectLot.vue";
import SSelectFarm from "@/components/HarvestSchedule/SSelectFarm";
import SCertificationLot from "@/components/TecnicalAssistence/sCertificationLot.vue";
import SSelectTransport from "@/components/HarvestSchedule/SSelectTransport";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety";
import SSelectForeman from "@/components/HarvestSchedule/SSelectForeman";
import SSelectDriver from "@/components/HarvestSchedule/sSelectDriver.vue";
import AlertSupplies from "@/components/FreshProduction/FreshReception/AlertSupplies.vue";
import sSelectTypeCertification from "@/components/Utils/Certification/sSelectTypeCertification.vue";
import s_HarvestSchedule from "@/services/Technicalassistance/HarvestSchedule.js";
import _sGeneral from "@/services/HelperService.js";
import _constapp from "@/plugins/const";
import GuidePdf from "./ReceptionSurveillancePdf.vue";
import sSelectReceptionSurveillanceGang from "@/components/ReceptionSurveillance/sSelectReceptionSurveillanceGang";
import { QrcodeCapture } from "vue-qrcode-reader";
import AlertSunshine from "@/components/Utils/AlertSunshine.vue";

import _CertificationsService from "../../../services/Technicalassistance/CertificationsService.js";
import _sHarvestSchedule from "../../../services/Technicalassistance/HarvestSchedule.js";
import _sTasGroupZonService from "../../../services/Technicalassistance/TasGroupZonService";

export default {
    components: {
        SSelectLot,
        SSelectTransport,
        SSelectVariety,
        SSelectForeman,
        SSelectDriver,
        SCertificationLot,
        AlertSupplies,
        SSearchLotByCodSenasa,
        sSelectTypeCertification,
        SSelectFarm,
        GuidePdf,
        sSelectReceptionSurveillanceGang,
        QrcodeCapture,
        AlertSunshine,
    },
    data: () => ({
        disabled: false,
        currentForemanForModal: null,
        headersHarvestersModal: [
            { text: "Nro. Documento", value: "PrsDocumentNumber", width: "120px", sortable: false },
            { text: "Nombre Completo", value: "FullName", sortable: false }
        ],
        showHarvestersModal: false,
        selectedGang: [],
        selectedVehicle: [],
        itemsGang: [],
        itemsVehicle: [],
        RcsPaymentZone: null,
        ZonesGroup: [],
        headersGang: [
            { text: "Placa", value: "VehPlate", width: 150 },
            { text: "Chofer", value: "DriverName", width: 200 },
            { text: "SubLote", value: "FltName", width: 200 },
            { text: "Capataz", value: "FrmName", width: 200 },
            { text: "Cant. Personal.", value: "FrmQuantityHarvester", width: 120 },
            { text: "Cant. Jabas Prog.", value: "FrmQuantityEstimate", width: 100 },
            { text: "Cant. Jabas Cosechadas", value: "FrmQuantityReal", width: 100 },
            { text: "Guia Remisión", value: "TasGngNumberGuideRemitente", width: 100 },
            { text: "Guia Remisión Mat.", value: "TasGngNumberGuideMaterials", width: 100 },
            { text: "Guia Transportista Fruta", value: "TasGngGuideTransport", width: 100 },
            { text: "Guia Transportista Materiales", value: "TasGngGuideTransportMaterials", width: 100 },
            { text: "Placa Transporte de personal.", value: "VehPlateSecondary", width: 150 },
        ],

        headersVehicle: [
            { text: "ID", value: "TptEnrollment", width: 150 },
            { text: "Placa", value: "TptEnrollment", width: 150 },
            { text: "Tipo de Carga", value: "TptVehicle", width: 100 },
            { text: "Chofer", value: "TptDriver", width: 200 },
            /* { text: "Capataz", value: "TptFrmName", width: 100 },
              { text: "Guia Remision", value: "TptNumberReferralGuide", width: 100 } */
        ],

        filter: {
            cDateInitial: null,
            cDateFin: null,
            filterAll: 0,
            cState: 2,
            HvsID: null,
        },

        config: {
            service: _sReceptionSurveillance,
            model: {
                HvsID: "ID",
                RcsDateHarvestSchedule: "date",
                RcsDateReception: "date",
                ViewCert: "",
                UploadFile: "",
                Transfer: "",
            },
            headers: [
                { text: "View", value: "ViewCert", width: 80, sortable: false },
                { text: "Adjunto", value: "UploadFile", width: 80, sortable: false },
                { text: "Transbordos", value: "Transfer", width: 80, sortable: false },
                { text: "Nro. Prog.", value: "HvsID", width: 100, sortable: true },
                { text: "Fec. Prog.", value: "RcsDateHarvestSchedule", width: 140, sortable: true },
                { text: "Productor", value: "PrdCardName", width: 300, sortable: true },
                { text: "Fundo", value: "FagName", width: 300, sortable: true },
                { text: "Lote_ID", value: "FltID", width: 100, sortable: true },
                { text: "Lote", value: "FltName", width: 100, sortable: true },
                { text: "Cultivo", value: "TypeCultiveName", width: 100, sortable: true },
                { text: "Variedad", value: "VrtName", width: 100, sortable: true },
                { text: "Fec. Recepcion", value: "RcsDateReception", width: 140, sortable: true },
                { text: "Cod. Senasa", value: "FltCodSenasa", width: 150, sortable: true },
                { text: "Guia Cosecha.", value: "RcsNumberHarvestGuide", width: 140, sortable: true },
                { text: "Guia Remision.", value: "RcsNumberReferralGuide", width: 140, sortable: true },
                { text: "Prec. Senasa", value: "RcsSenasaSeal", width: 140, sortable: true },
                { text: "Pre. Sunshine", value: "RcsSunshineSeal", width: 340, sortable: true },
                { text: "Observaciones", value: "RcsObservations", width: 140 },
                /* { text: "Estado",               value: "RcsState", width: 30 }, */
            ],
        },

        selected: {},
        dialogGuidePdf: false,
        openDialogView: false,
        openDialogUploadFile: false,
        Attach: null,
        AttachPDF: {},
        AttachXML: {},
        AttachPDFMaterials: {},
        AttachXMLMaterials: {},
        XMLSummary: {},
        //listSupplies: [],
        //hasSuppliesNotRecommended: false,
        existsData: false,

        //Obj Lot
        objLot: { PrdText: null, FagName: null, FltName: null },
        FltID: 0,

        maskFormatGuideHarvested: "",
        maskFormatGuideRemission: "",

        xCount: 0,
        objTransport: null,
        alertCertification: false,

        processing: false,
        error: false,
        messageProcessing: "",
        isLoading: false,

        dialogTransfer: false,
        configTransfer: {
            service: _sReceptionTransfer,
            model: {
                TrtID: "ID",
                // SecCreate: "date",
                TransferDate: "date",
            },
            headers: [
                // { text: "ID", value: "TrtID", width: 40, sortable: false, },
                // { text: "Fecha", value: "SecCreate", width: 70, align: "center", sortable: false },
                { text: "Fecha transbordo", value: "TransferDate", width: 70, align: "center", sortable: false },
                { text: "Cantidad", value: "TransferQuantity", width: 80, sortable: false },
                { text: "Vehículo", value: "TypeVehicleName", width: 80, sortable: false },
                { text: "Placa", value: "VehPlate", width: 80, sortable: false },
                // { text: "Capacidad", value: "CfvCapacity", width: 80, sortable: true, },
                { text: "Cap. min", value: "CapacityMax", width: 80, sortable: true },
                { text: "Cap. Máx", value: "CapacityMax", width: 80, sortable: true },
                { text: "Tipo Carga", value: "ArcName", width: 90, sortable: false },
                { text: "Conductor", value: "TrtDriverDNI", width: 300, sortable: false },
                { text: "Capataz", value: "ForemanDNI", width: 300, sortable: false },
                { text: "Adjunto", value: "UploadFile", width: 80, align: "center", sortable: false },
            ],
        },
        filterTransfer: {
            HvsID: null,
            DateBegin: null,
            DateEnd: null,
        },
        messageValidation: null,
        AttachTransfer: null,
        formTransfer: {
            TrtID: 0,
            HvsID: null,
            VehPlate: null,
            TrtDriverID: null,
            TrtDriverName: null,
            CfvCapacity: 0,
            TypeVehicleName: null,
            UploadFile: null,
            Quantity: 0,
            TypeLoad: 1,
            SecStatus: 1,
            FrmID: 0,
            TransferQuantity: 0,
            TransferDate: null,
        },
        // Lector QR
        qrFile: null,
        qrImagePreview: null,
        qrDecodedContent: "",
        qrDecoding: false,
        qrError: "",
        qrDragOver: false,
        qrSavingInProgress: false,
        retrievedImagePreview: null,
        qrValidationFailed: false,
        qrIsReviewMode: false,
        loadingCalculate: false,
        textLoading: "",
    }),
    created() {
        this.loadParameter();
    },
    computed: {
        uniquePlates() {
            if (!this.itemsGang || !Array.isArray(this.itemsGang)) return [];
            const plates = this.itemsGang.filter(item => item && item.VehPlate)
                .map(item => String(item.VehPlate).trim()).filter(plate => plate !== '');
            return [...new Set(plates)];
        },
        parsedQrData() {
            if (!this.qrDecodedContent) return [];
            const content = this.qrDecodedContent.trim();

            // Funciones auxiliares para normalización y comparación robusta
            const normalizeString = (str) => {
                if (!str) return "";
                return String(str)
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "") // quitar acentos
                    .replace(/[^a-z0-9]/g, ""); // conservar sólo letras y números
            };

            const extractDateOnly = (str) => {
                if (!str) return "";
                // Extraer formato DD/MM/YYYY o YYYY-MM-DD
                const match = str.match(/(\d{2})[/-](\d{2})[/-](\d{4})/);
                if (match) return `${match[1]}/${match[2]}/${match[3]}`;
                const matchYmd = str.match(/(\d{4})[/-](\d{2})[/-](\d{2})/);
                if (matchYmd) return `${matchYmd[3]}/${matchYmd[2]}/${matchYmd[1]}`;
                return str.split(',')[0].trim();
            };

            const extractNumber = (str) => {
                if (!str) return null;
                const match = str.match(/\d+(\.\d+)?/);
                return match ? parseFloat(match[0]) : null;
            };

            let result = [];

            // 0. Detectar formato personalizado de Clave-Valor (e.g. -Exportador->...)
            if (content.includes('->')) {
                const regex = /-([^\r\n\-&=>]+)->/g;
                const keys = [];
                let match;
                while ((match = regex.exec(content)) !== null) {
                    keys.push({
                        name: match[1].trim(),
                        index: match.index,
                        length: match[0].length
                    });
                }

                if (keys.length > 0) {
                    for (let i = 0; i < keys.length; i++) {
                        const currentKey = keys[i];
                        const valueStart = currentKey.index + currentKey.length;
                        const valueEnd = (i + 1 < keys.length) ? keys[i + 1].index : content.length;
                        const value = content.substring(valueStart, valueEnd).trim();
                        result.push({
                            label: currentKey.name,
                            value: value || '-'
                        });
                    }
                }
            }
            // 1. Detectar si es el formato de SUNAT (separado por pipes '|')
            else if (content.includes('|')) {
                const parts = content.split('|');
                const labels = [
                    "RUC Emisor",
                    "Tipo Documento",
                    "Serie",
                    "Número Correlativo",
                    "Impuesto / Valor",
                    "Total",
                    "Fecha Emisión",
                    "Tipo Doc. Adquiriente",
                    "Nro. Doc. Adquiriente",
                    "Hash / Firma"
                ];

                const getDocTypeName = (type) => {
                    if (type === '09') return 'Guía de Remisión Remitente';
                    if (type === '31') return 'Guía de Remisión Transportista';
                    if (type === '01') return 'Factura Electrónica';
                    if (type === '03') return 'Boleta de Venta';
                    return type;
                };

                result = parts.map((part, index) => {
                    let label = labels[index] || `Dato Adicional ${index + 1}`;
                    let val = part.trim();
                    if (index === 1) val = `${val} - ${getDocTypeName(val)}`;
                    return { label, value: val || '-' };
                });
            }
            // 2. Detectar si es una URL con parámetros de consulta
            else if (content.startsWith('http://') || content.startsWith('https://')) {
                try {
                    const url = new URL(content);
                    result.push({ label: 'Enlace / URL', value: content });
                    result.push({ label: 'Dominio', value: url.hostname });

                    url.searchParams.forEach((val, key) => {
                        let label = key;
                        const keyLower = key.toLowerCase();
                        if (keyLower === 'rucemisor') label = 'RUC Emisor';
                        else if (keyLower === 'serienumero') label = 'Serie-Número';
                        else if (keyLower === 'fechaemision') label = 'Fecha Emisión';
                        else if (keyLower === 'ruc') label = 'RUC';
                        else if (keyLower === 'nro') label = 'Número';
                        else if (keyLower === 'placa') label = 'Placa';

                        result.push({ label, value: val });
                    });
                } catch (e) {
                    // Fallback
                }
            }
            // 3. Detectar si es JSON
            else if (content.startsWith('{') && content.endsWith('}')) {
                try {
                    const obj = JSON.parse(content);
                    result = Object.entries(obj).map(([key, val]) => {
                        const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
                        return { label, value: String(val) };
                    });
                } catch (e) {
                    // Fallback
                }
            }
            // 4. Texto simple
            else {
                result = [
                    { label: 'Tipo de Lectura', value: 'Texto Genérico / Código Único' },
                    { label: 'Contenido QR', value: content }
                ];
            }

            // Realizar las validaciones cruzadas si hay datos disponibles
            if (result.length > 0) {
                const qrPlacaObj = result.find(item => {
                    const l = normalizeString(item.label);
                    return l === 'placa' || l === 'vehplate' || l === 'nroplaca';
                });
                const qrJabasObj = result.find(item => {
                    const l = normalizeString(item.label);
                    return l === 'jabas' || l === 'cantidad' || l === 'cantjabas' || l === 'jabasreal' || l === 'jabasreales';
                });

                result = result.map(item => {
                    const labelNorm = normalizeString(item.label);
                    const valNorm = normalizeString(item.value);
                    let validation = null;

                    // 1. LugarProd vs Cod. Senasa (objLot.FltCodSenasa)
                    if (labelNorm === 'lugarprod') {
                        const formSenasa = this.objLot ? this.objLot.FltCodSenasa : '';
                        const formSenasaNorm = normalizeString(formSenasa);
                        if (formSenasaNorm) {
                            const match = valNorm === formSenasaNorm;
                            validation = {
                                isValid: match,
                                expected: formSenasa,
                                message: match ? 'Coincide con Cod. Senasa' : `No coincide con Cod. Senasa (${formSenasa})`
                            };
                        } else {
                            validation = { isValid: false, expected: 'No asignado', message: 'Cod. Senasa no asignado en el lote del formulario' };
                        }
                    }

                    // 2. Placa vs Capataz Programados y Jabas vs Jabas Cosechadas
                    else if (labelNorm === 'placa' || labelNorm === 'vehplate' || labelNorm === 'nroplaca') {
                        const vehList = this.itemsVehicle || [];
                        const normalizedPlacaVal = normalizeString(item.value);

                        const matchingGang = vehList.find(g => normalizeString(g.TptEnrollment) === normalizedPlacaVal);

                        if (matchingGang) {
                            let jabasMatch = true;
                            let jabasMessage = "";
                            const expectedRealJabas = this.itemsGang.reduce((sum, item) => sum + (item.FrmQuantityReal || 0), 0);
                            // const expectedRealJabas = matchingGang.FrmQuantityReal || 0;

                            if (qrJabasObj) {
                                const qrJabasNum = extractNumber(qrJabasObj.value);
                                if (qrJabasNum !== null && Number(expectedRealJabas) !== qrJabasNum) {
                                    jabasMatch = false;
                                    jabasMessage = ` (QR: ${qrJabasNum} und vs Prog: ${expectedRealJabas} und)`;
                                }
                            }

                            validation = {
                                isValid: jabasMatch,
                                expected: matchingGang.VehPlate,
                                message: jabasMatch
                                    ? 'Coincide con Placa y Jabas Cosechadas'
                                    : `Placa coincide, pero las jabas cosechadas no coinciden${jabasMessage}`
                            };
                        } else {
                            validation = {
                                isValid: false,
                                expected: 'Placa en Capataces',
                                message: 'La placa no coincide con los Capataces Programados'
                            };
                        }
                    }

                    // 3. Validar fila Jabas directamente
                    else if (labelNorm === 'jabas' || labelNorm === 'cantidad' || labelNorm === 'cantjabas' || labelNorm === 'jabasreal' || labelNorm === 'jabasreales') {
                        const vehList = this.itemsVehicle || [];
                        const qrPlacaVal = qrPlacaObj ? normalizeString(qrPlacaObj.value) : '';
                        // const matchingGang = vehList.find(g => normalizeString(g.VehPlate) === qrPlacaVal);
                        const matchingGang = vehList.find(g => normalizeString(g.TptEnrollment) === qrPlacaVal);

                        if (matchingGang) {
                            // const expectedRealJabas = Number(matchingGang.FrmQuantityReal) || 0;
                            const expectedRealJabas = this.itemsGang.reduce((sum, item) => sum + (item.FrmQuantityReal || 0), 0);
                            const qrJabasNum = extractNumber(item.value);
                            const match = qrJabasNum !== null && qrJabasNum === expectedRealJabas;
                            validation = {
                                isValid: match,
                                expected: `${expectedRealJabas} und`,
                                message: match ? 'Coincide con Jabas Cosechadas' : `No coincide con Jabas Cosechadas (${expectedRealJabas} und)`
                            };
                        } else {
                            validation = {
                                isValid: false,
                                expected: 'Jabas Cosechadas',
                                message: 'No se puede validar porque la placa no coincide o no está en el QR'
                            };
                        }
                    }

                    // 4. Producto vs Cultivo y Variedad (TypeCultiveName + VrtName en selected)
                    else if (labelNorm === 'producto') {
                        const typeCultiveName = (this.selected && this.selected.TypeCultiveName) ? String(this.selected.TypeCultiveName).trim() : '';
                        const vrtName = (this.selected && this.selected.VrtName) ? String(this.selected.VrtName).trim() : '';
                        const targetProduct = `${typeCultiveName} ${vrtName}`.trim();

                        if (targetProduct) {
                            const normalizeForWords = (s) => {
                                if (!s) return "";
                                return String(s)
                                    .toLowerCase()
                                    .normalize("NFD")
                                    .replace(/[\u0300-\u036f]/g, "")
                                    .replace(/[^a-z0-9\s]/g, "")
                                    .trim();
                            };

                            const qrValLower = normalizeForWords(item.value).replace(/\bpalto\b/g, 'palta').replace(/\bpaltos\b/g, 'palta');
                            const targetValLower = normalizeForWords(targetProduct).replace(/\bpalto\b/g, 'palta').replace(/\bpaltos\b/g, 'palta');

                            const wordsQr = qrValLower.split(/\s+/).filter(Boolean);
                            const wordsTarget = targetValLower.split(/\s+/).filter(Boolean);

                            let matches = 0;
                            if (wordsQr.length > 0 && wordsTarget.length > 0) {
                                const used = new Set();
                                for (const wQr of wordsQr) {
                                    for (let i = 0; i < wordsTarget.length; i++) {
                                        if (!used.has(i) && (wordsTarget[i] === wQr || wordsTarget[i].includes(wQr) || wQr.includes(wordsTarget[i]))) {
                                            matches++;
                                            used.add(i);
                                            break;
                                        }
                                    }
                                }
                            }

                            const maxWords = Math.max(wordsQr.length, wordsTarget.length);
                            const similarity = maxWords > 0 ? Math.round((matches / maxWords) * 100) : 0;
                            const match = similarity >= 40 || qrValLower.includes(targetValLower) || targetValLower.includes(qrValLower);

                            console.log("Palabras QR:", wordsQr);
                            console.log("Palabras Esperadas:", wordsTarget);
                            console.log("Porcentaje Similitud:", similarity + "%");

                            validation = {
                                isValid: match,
                                expected: targetProduct,
                                message: match
                                    ? `Coincide con Cultivo/Variedad (${similarity}% de coincidencia)`
                                    : `No coincide con Cultivo/Variedad (${similarity}% de coincidencia, esperado: ${targetProduct})`
                            };
                        } else {
                            console.log("=== COMPARACION PRODUCTO QR === Cultivo/Variedad no asignado en el sistema.");
                            validation = { isValid: false, expected: 'No asignado', message: 'Cultivo/Variedad no asignado en el formulario' };
                        }
                    }

                    // 5. Guia Nro vs Guia Remisión Fruta (RcsNumberReferralGuide)
                    else if (labelNorm === 'guianro' || labelNorm === 'guia') {
                        const formGuia = this.selected ? this.selected.RcsNumberReferralGuide : '';
                        const formGuiaNorm = normalizeString(formGuia);
                        if (formGuiaNorm) {
                            const match = valNorm === formGuiaNorm;
                            validation = {
                                isValid: match,
                                expected: formGuia,
                                message: match ? 'Coincide con Guía de Remisión' : `No coincide con Guía de Remisión (${formGuia})`
                            };
                        } else {
                            validation = { isValid: false, expected: 'No asignado', message: 'Guía de Remisión no asignada en el formulario' };
                        }
                    }

                    // 6. Fecha Registro vs Fecha Cosecha Programada (RcsDateHarvestSchedule)
                    else if (labelNorm === 'fecharegistro') {
                        const formFecha = this.selected ? this.selected.RcsDateHarvestSchedule : '';
                        const qrDateOnly = extractDateOnly(item.value);
                        const formDateOnly = extractDateOnly(formFecha);
                        if (formDateOnly) {
                            const match = qrDateOnly === formDateOnly;
                            validation = {
                                isValid: match,
                                expected: formFecha,
                                message: match ? 'Coincide con Fecha Cosecha Programada' : `No coincide con Fecha Cosecha (${formFecha})`
                            };
                        } else {
                            validation = { isValid: false, expected: 'No asignado', message: 'Fecha Cosecha no asignada en el formulario' };
                        }
                    }

                    return {
                        ...item,
                        validation
                    };
                });
            }

            return result;
        }
    },
    watch: {},

    methods: {
        triggerQrFileInput() {
            console.log("triggerQrFileInput called, disabled state:", this.disabled);
            const input = this.$refs.qrFileInput;
            if (input) {
                console.log("Found qrFileInput ref:", input);
                if (Array.isArray(input)) {
                    if (input[0]) input[0].click();
                } else {
                    input.click();
                }
            } else {
                console.warn("qrFileInput ref not found!");
            }
        },
        onQrFileSelected(e) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.processQrFile(files[0]);
        },
        onQrFileDrop(e) {
            this.qrDragOver = false;
            const files = e.dataTransfer.files;
            if (!files.length) return;
            this.processQrFile(files[0]);
        },
        processQrFile(file) {
            this.qrError = "";
            this.qrDecodedContent = "";
            this.qrValidationFailed = false;

            // Validar que sea una imagen
            if (!file || !file.type || !file.type.startsWith('image/')) {
                this.qrError = "El archivo seleccionado no es una imagen válida (Formatos soportados: JPG, PNG, WEBP, etc.)";
                this.Attach = null;
                this.qrFile = null;
                this.qrImagePreview = null;
                return;
            }

            this.Attach = file;
            this.qrFile = file;
            this.qrDecoding = true;
            this.qrValidationFailed = true;
            this.qrIsReviewMode = false;
            this.textLoading = "Analizando y decodificando código QR...";
            this.loadingCalculate = true;

            // Generar previsualización
            this.qrImagePreview = URL.createObjectURL(file);

            // Programar la decodificación pasando el archivo a QrcodeCapture
            this.$nextTick(() => {
                try {
                    const captureComponent = this.$refs.qrCapture;
                    if (captureComponent) {
                        const inputEl = captureComponent.$el;
                        const targetInput = inputEl.tagName === 'INPUT' ? inputEl : inputEl.querySelector('input');
                        if (targetInput) {
                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(file);
                            targetInput.files = dataTransfer.files;
                            targetInput.dispatchEvent(new Event('change'));
                        } else {
                            this.qrDecoding = false;
                            this.loadingCalculate = false;
                            this.qrError = "Error al iniciar el descodificador de QR.";
                        }
                    } else {
                        this.qrDecoding = false;
                        this.loadingCalculate = false;
                        this.qrError = "Lector QR no inicializado.";
                    }
                } catch (err) {
                    console.error("Error setting file for QrcodeCapture", err);
                    this.qrDecoding = false;
                    this.loadingCalculate = false;
                    this.qrError = "Error interno al decodificar la imagen.";
                }
            });
        },
        onQrDecode(result) {
            console.log("QR decoded:", result);
            this.qrDecodedContent = result;
            this.qrDecoding = false;
            this.loadingCalculate = false;

            if (!this.qrIsReviewMode) {
                this.$fun.alert("Código QR decodificado exitosamente", "success");
            }
            this.checkQrValidationAndSave();
        },
        onQrDetect(promise) {
            promise.then((result) => {
                if (result && result.content) {
                    this.qrDecodedContent = result.content;
                    this.checkQrValidationAndSave();
                } else {
                    if (!this.qrDecodedContent) {
                        this.qrError = "No se detectó ningún código QR en la imagen. Intente con otra foto más clara.";
                        this.qrValidationFailed = true;
                    }
                }
            }).catch((err) => {
                console.error("Error detecting QR:", err);
                this.qrError = "Error al analizar la imagen. Asegúrese de que contenga un código QR legible.";
                this.qrValidationFailed = true;
            }).finally(() => {
                this.qrDecoding = false;
                this.loadingCalculate = false;
            });
        },
        clearQrScanner() {
            this.Attach = null;
            this.qrFile = null;
            if (this.qrImagePreview) {
                URL.revokeObjectURL(this.qrImagePreview);
            }
            this.qrImagePreview = null;
            this.qrDecodedContent = "";
            this.qrDecoding = false;
            this.qrError = "";
            this.qrSavingInProgress = false;
            this.qrValidationFailed = false;
            this.qrIsReviewMode = false;
            if (this.retrievedImagePreview) {
                if (typeof this.retrievedImagePreview === 'string' && this.retrievedImagePreview.startsWith("blob:")) {
                    URL.revokeObjectURL(this.retrievedImagePreview);
                }
            }
            this.retrievedImagePreview = null;
            if (this.$refs.qrFileInput) {
                this.$refs.qrFileInput.value = "";
            }
        },
        checkQrValidationAndSave() {
            this.$nextTick(() => {
                if (this.qrSavingInProgress) return;

                const validatedItems = this.parsedQrData.filter(item => item.validation);
                if (validatedItems.length > 0) {
                    const validCount = validatedItems.filter(item => item.validation.isValid).length;
                    const invalidItems = validatedItems.filter(item => !item.validation.isValid);

                    if (invalidItems.length === 0) {
                        this.qrValidationFailed = false;
                        if (!this.qrIsReviewMode) {
                            this.qrSavingInProgress = true;
                            this.$fun.alert("Coincidencia exitosa de todos los datos. Guardando automáticamente...", "success");
                            this.saveFile();
                        }
                        return;
                    }

                    // Separar discrepancias blandas (producto, fecha) y primordiales (placa, jabas, lugarprod, guia, etc.)
                    const softMismatches = invalidItems.filter(item => {
                        const l = item.label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        return l.includes("producto") || l.includes("fecha");
                    });

                    const hardMismatches = invalidItems.filter(item => {
                        const l = item.label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        return !l.includes("producto") && !l.includes("fecha");
                    });

                    if (hardMismatches.length > 0) {
                        // Error de coincidencia en datos primordiales: bloquear guardado
                        this.qrValidationFailed = true;
                        if (!this.qrIsReviewMode) {
                            this.$fun.alert("El QR no cumple con los requisitos de los datos.", "error");
                        }
                        this.qrSavingInProgress = false;
                    } else if (softMismatches.length > 0) {
                        // Discrepancia sólo en datos blandos (nombres/fechas): permitir confirmación
                        this.qrValidationFailed = false;
                        if (!this.qrIsReviewMode) {
                            this.qrSavingInProgress = true;
                            const mismatchedLabels = softMismatches.map(item => item.label).join(", ");
                            this.$fun.alert(`Se detectaron discrepancias en: ${mismatchedLabels}. ¿Desea confirmar y guardar el archivo de todas formas o cancelar?`, "question")
                                .then((confirm) => {
                                    if (confirm.value) {
                                        this.saveFile();
                                    } else {
                                        this.$fun.alert("Guardado cancelado por el usuario.", "info");
                                        this.qrSavingInProgress = false;
                                    }
                                });
                        }
                    }
                } else {
                    this.qrValidationFailed = true;
                }
            });
        },
        handleSaveFileClick() {
            const validatedItems = this.parsedQrData.filter(item => item.validation);
            if (validatedItems.length > 0) {
                const invalidItems = validatedItems.filter(item => !item.validation.isValid);
                if (invalidItems.length > 0) {
                    const softMismatches = invalidItems.filter(item => {
                        const l = item.label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        return l.includes("producto") || l.includes("fecha");
                    });

                    const hardMismatches = invalidItems.filter(item => {
                        const l = item.label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        return !l.includes("producto") && !l.includes("fecha");
                    });

                    if (hardMismatches.length > 0) {
                        this.$fun.alert("El QR no cumple con los requisitos de los datos.", "error");
                        return;
                    }

                    if (softMismatches.length > 0) {
                        const mismatchedLabels = softMismatches.map(item => item.label).join(", ");
                        this.$fun.alert(`Se detectaron discrepancias en: ${mismatchedLabels}. ¿Desea confirmar y guardar el archivo de todas formas o cancelar?`, "question")
                            .then((confirm) => {
                                if (confirm.value) {
                                    this.saveFile();
                                }
                            });
                        return;
                    }
                }
            } else {
                this.$fun.alert("El código QR no contiene datos válidos para esta programación o no se ha podido decodificar.", "error");
                return;
            }
            this.saveFile();
        },
        /* dblclickTraspot({item}){
            this.objTransport=item;
            if(this.selectedGang.length > 0){
              this.selectedGang[0].VehPlate = item.VehPlate;
              this.selectedGang[0].DriverName = item.Driver;
              this.selectedGang[0].NtpIDDriver = item.NtpIDDriver;
              console.log(item);
            }
    
          }, */
        downloadGuide() {
            this.dataPdf = {
                ...this.selected,
                GetGang: [],
                GetVehicle: [],
                getCertGlobal: false,
                GetCertRainForest: false,
            };
            (this.isLoading = false),
                Promise.all([
                    _sReceptionSurveillance.GetGang({ HvsID: this.selected.HvsID }, this.$fun.getUserID()).then((r) => {
                        this.itemsGang = r.data.map(x => ({ ...x, TasGngNumberGuideRemitente: !x.TasGngNumberGuideRemitente ? this.selected.RcsNumberReferralGuide : x.TasGngNumberGuideRemitente }));
                        this.dataPdf.GetGang = this.itemsGang;
                    }),

                    _sReceptionSurveillance.GetTransport({ HvsID: this.selected.HvsID }, this.$fun.getUserID()).then((r) => {
                        this.itemsVehicle = r.data;
                        this.dataPdf.GetVehicle = this.itemsVehicle.length ? this.itemsVehicle[0] : {};
                    }),
                    _sReceptionSurveillance.getCertGlobal(this.selected.FltID, this.$fun.getUserID()).then((r) => {
                        //console.log("📄 getCertGlobal", r.data);
                        this.dataPdf.getCertGlobal = r.data;
                    }),

                    _sReceptionSurveillance.getCertRainForest(this.selected.FltID, this.$fun.getUserID()).then((r) => {
                        //console.log("📄 getCertRainForest", r.data);
                        this.dataPdf.getCertRainForest = r.data;
                    }),
                ]).then(() => {
                    this.dialogGuidePdf = true; // 🔥 Solo abrimos el modal cuando todo esté listo
                }).finally(() => {
                    this.isLoading = false;
                });
        },
        loadParameter() {
            _sGenParam.search({ PrmName: "maskFormatGuideHarvested" }, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                    this.maskFormatGuideHarvested = resp.data.PrmValue;
                }
            });

            _sGenParam.search({ PrmName: "maskFormatGuideRemission" }, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                    this.maskFormatGuideRemission = resp.data.PrmValue;
                }
            });
        },
        rowClickGang: function (item, row) {
            this.selectedGang = [item];
            //this.objDriver.DriverName = item.DriverName;
            this.objTransport = {
                NtpIDID: item.NtpIDDriver,
                Driver: item.DriverName,
                VehPlate: item.VehPlate,
            };
            //console.log("this.selectedGang",this.objDriver);
        },

        rowClickVehicle: function (item, row) {
            this.selectedVehicle = [item];
        },

        clickView(val) {
            this.FltID = val.FltID;
            this.openDialogView = true;
        },

        processExistingFile(blobData, filename, mime) {
            const file = new File([blobData], filename, { type: mime });
            this.Attach = file;
            this.qrFile = file;
            this.qrDecoding = true;
            this.qrValidationFailed = false;
            this.qrImagePreview = URL.createObjectURL(file);

            this.$nextTick(() => {
                try {
                    const captureComponent = this.$refs.qrCapture;
                    if (captureComponent) {
                        const inputEl = captureComponent.$el;
                        const targetInput = inputEl.tagName === 'INPUT' ? inputEl : inputEl.querySelector('input');
                        if (targetInput) {
                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(file);
                            targetInput.files = dataTransfer.files;
                            targetInput.dispatchEvent(new Event('change'));
                        } else {
                            this.qrDecoding = false;
                            this.loadingCalculate = false;
                        }
                    } else {
                        this.qrDecoding = false;
                        this.loadingCalculate = false;
                    }
                } catch (err) {
                    console.error("Error decoding existing file:", err);
                    this.qrDecoding = false;
                    this.loadingCalculate = false;
                }
            });
        },

        clickUploadFile(val) {
            this.FltID = val.FltID;
            this.selected = val;
            this.openDialogUploadFile = true;
            this.retrievedImagePreview = null;
            this.qrIsReviewMode = val.HvsAttach ? true : false;

            if (val.HvsAttach) {
                this.Attach = { name: val.HvsAttach };
                const isImage = /\.(apng|avif|gif|jpg|jpeg|jfif|pjpeg|pjpg|png|svg|webp)$/i.test(val.HvsAttach);
                if (isImage) {
                    this.textLoading = "Descargando y decodificando adjunto...";
                    this.loadingCalculate = true;
                    _sGeneral.download(val.HvsAttach, this.$fun.getUserID()).then((r) => {
                        if (r && r.data) {
                            const ext = val.HvsAttach.split('.').pop().toLowerCase();
                            const mime = ext === 'png' ? 'image/png' : ext === 'webp' ? 'image/webp' : 'image/jpeg';
                            if (r.data instanceof Blob) {
                                this.processExistingFile(r.data, val.HvsAttach, mime);
                            } else {
                                const base64Data = r.data;
                                if (typeof base64Data === 'string') {
                                    const cleanBase64 = base64Data.startsWith('data:') ? base64Data.split(',')[1] : base64Data;
                                    const byteCharacters = atob(cleanBase64);
                                    const byteNumbers = new Array(byteCharacters.length);
                                    for (let i = 0; i < byteCharacters.length; i++) {
                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                    }
                                    const byteArray = new Uint8Array(byteNumbers);
                                    const blob = new Blob([byteArray], { type: mime });
                                    this.processExistingFile(blob, val.HvsAttach, mime);
                                } else {
                                    this.loadingCalculate = false;
                                }
                            }
                        } else {
                            this.loadingCalculate = false;
                        }
                    }).catch(err => {
                        console.error("Error downloading image preview:", err);
                        this.loadingCalculate = false;
                    });
                }
            } else {
                this.Attach = null;
            }
        },

        close() {
            this.openDialogView = false;
            this.openDialogUploadFile = false;
            this.clearQrScanner();
        },

        rowSelected(item) {
            if (!this.openDialogUploadFile) {
                this.clearQrScanner();
            }
            if (item.length == 0) {
                this.selected = { SecStatus: 1 };
                this.objLot = {};
                this.selected.RcsState = 0;
                this.itemsGang = [];
                this.itemsVehicle = [];
                this.existsData = false;
                this.disabled = true;
                this.objTransport = null;
                this.AttachPDF = {};
                this.AttachXML = {};
                this.AttachPDFMaterials = {};
                this.AttachXMLMaterials = {};
                this.XMLSummary = {};
                //this.hasSuppliesNotRecommended = false;
            } else {
                if (item[0] != undefined) {
                    this.selected = item[0];
                    this.existsData = true;
                    console.log("selected", JSON.parse(JSON.stringify(this.selected)));
                    this.getZonesGroup();

                    if (!this.openDialogUploadFile && this.selected.HvsAttach != null) {
                        this.Attach = { name: this.selected.HvsAttach };
                    }
                    _sReceptionSurveillance.GetGang({ HvsID: this.selected.HvsID }, this.$fun.getUserID()).then((r) => {
                        console.log(JSON.parse(JSON.stringify({ res: r.data })))
                        this.itemsGang = r.data.map(x => ({ ...x, TasGngNumberGuideRemitente: !x.TasGngNumberGuideRemitente ? this.selected.RcsNumberReferralGuide : x.TasGngNumberGuideRemitente }));
                        this.itemsGang.forEach(item => {
                            // Guardamos los valores originales para saber qué archivos ya existen en el servidor
                            this.$set(item, '_originalTasGngGuideTransport', item.TasGngGuideTransport);
                            this.$set(item, '_originalTasGngGuideTransportMaterials', item.TasGngGuideTransportMaterials);

                            if (item.TasGngNumberGuideRemitente) {
                                if (!this.XMLSummary[item.VehPlate]) this.$set(this.XMLSummary, item.VehPlate, {});
                                this.$set(this.XMLSummary[item.VehPlate], 'fruta', {
                                    isValid: true,
                                    nroGuia: item.TasGngGuideTransport,
                                    guiaRemitente: item.TasGngNumberGuideRemitente,
                                    placa: item.VehPlate
                                });
                            }
                            if (item.TasGngNumberGuideMaterials) {
                                if (!this.XMLSummary[item.VehPlate]) this.$set(this.XMLSummary, item.VehPlate, {});
                                this.$set(this.XMLSummary[item.VehPlate], 'materiales', {
                                    isValid: true,
                                    nroGuia: item.TasGngGuideTransportMaterials,
                                    guiaRemitente: item.TasGngNumberGuideMaterials,
                                    placa: item.VehPlate
                                });
                            }
                        });
                        // console.log("itemsGang", JSON.parse(JSON.stringify(r.data)));
                    });

                    _sReceptionSurveillance.GetTransport({ HvsID: this.selected.HvsID }, this.$fun.getUserID()).then((r) => {
                        this.itemsVehicle = r.data;
                        console.log("this.itemsVehicle", JSON.parse(JSON.stringify(this.itemsVehicle)));
                    });
                    this.dataPdf = this.selected;
                    //console.log("itemsGang", this.itemsGang);
                    //console.log("itemsVehicle", this.itemsVehicle);

                    this.dataPdf.GetGang = this.itemsGang[0];
                    this.dataPdf.GetTransport = this.itemsVehicle[0];
                    //console.log("dataPdf", this.dataPdf);

                    this.objLot.PrdText = this.selected.PrdCardName;
                    this.objLot.FagName = this.selected.FagName;
                    this.objLot.FltName = this.selected.FltName;

                    this.objLot.PrdID = this.selected.PrdID;
                    this.objLot.FagID = this.selected.FagID;
                    this.objLot.FltID = this.selected.FltID;
                    this.objLot.FltCodSenasa = this.selected.FltCodSenasa;

                    this.objLot.TypeCrop = this.selected.TypeCrop;
                    this.objLot.TypeCultive = this.selected.TypeCultive;
                    this.objLot.VrtID = this.selected.VrtID;

                    this.objLot.FagAddress = this.selected.FagAddres;
                    this.objLot.ZonIDText = this.selected.ZonName;
                    this.objLot.SzoIDText = this.selected.SzoName;
                    this.objLot.TypeNegociation = this.selected.TypeNegociation;

                    if (this.selected.RcsState == 1) {
                        this.disabled = true;
                    } else {
                        this.disabled = false;
                    }
                }
            }
        },

        isValidatedForeman() {
            let isValidated = true;
            //Validar Grilla Capataces
            if (this.itemsGang.length == 0) {
                this.$fun.alert("La Programacion: " + this.selected.HvsID + ", No cuenta con Capataces asignados.", "warning");
                isValidated = false;
                return;
            }

            this.itemsGang.forEach((element) => {
                if (element.FrmID == null) {
                    this.$fun.alert("Uno de los registro no se ha cargado Capataz", "warning");
                    isValidated = false;
                    return;
                }

                if (element.FltID == null) {
                    this.$fun.alert("Uno de los registro no se ha cargado Sub-Lote", "warning");
                    isValidated = false;
                    return;
                }

                if (element.FrmQuantityHarvester <= 0) {
                    this.$fun.alert("Cantidad de Cosechadores no puede ser menor o igual a 0, para Capataz: " + element.FrmName, "warning");
                    isValidated = false;
                    return;
                }

                if (element.FrmQuantityReal <= 0) {
                    this.$fun.alert("Cantidad de Fruta no puede ser menor o igual a 0, para Capataz: " + element.FrmName, "warning");
                    isValidated = false;
                    return;
                }

                if (element.TasGngNumberGuideRemitente == null || element.TasGngNumberGuideRemitente == "") {
                    this.$fun.alert(`Ingresar Guía de Remisión Remitente de Fruta para la placa ${element.VehPlate}.`, "warning");
                    isValidated = false;
                    return;
                }

                if (element.TasGngNumberGuideMaterials == null || element.TasGngNumberGuideMaterials == "") {
                    this.$fun.alert(`Ingresar Guía de Remisión Remitente de Materiales para la placa ${element.VehPlate}.`, "warning");
                    isValidated = false;
                    return;
                }

                if (element.TasGngGuideTransport == null || element.TasGngGuideTransport == "") {
                    this.$fun.alert(`Ingresar Guía de Transportista de Fruta para la placa ${element.VehPlate}.`, "warning");
                    isValidated = false;
                    return;
                }

                if (element.TasGngGuideTransportMaterials == null || element.TasGngGuideTransportMaterials == "") {
                    this.$fun.alert(`Ingresar Guía de Transportista de Materiales para la placa ${element.VehPlate}.`, "warning");
                    isValidated = false;
                    return;
                }

                // if (element.TasGngGuideTransport == null || element.TasGngGuideTransport == "") {
                //     this.$fun.alert(`Debe adjuntar la Guía Remisión Transportista (PDF y XML) de Fruta para la placa ${element.VehPlate} ya que cuenta con jabas cosechadas.`, "warning");
                //     isValidated = false;
                //     return;
                // }

                // if (element.TasGngGuideTransportMaterials == null || element.TasGngGuideTransportMaterials == "") {
                //     this.$fun.alert(`Debe adjuntar la Guía Remisión Transportista (PDF y XML) de Materiales para la placa ${element.VehPlate} ya que cuenta con jabas cosechadas.`, "warning");
                //     isValidated = false;
                //     return;
                // }
            });

            return isValidated;
        },

        isValidatedVehicle() {
            //Validar Grilla Vehiculos
            let isValidated = true;
            if (this.itemsVehicle.length == 0) {
                this.$fun.alert("La Programacion: " + this.selected.HvsID + ", No cuenta con Vehiculos asignados.", "warning");
                isValidated = false;
                return;
            }

            this.itemsVehicle.forEach((element) => {
                if (element.TptEnrollment == null) {
                    this.$fun.alert("Necesita especificar un Vehiculo", "warning");
                    isValidated = false;
                    return;
                }

                if (element.TptDriver == null) {
                    this.$fun.alert("Necesita especificar un Chofer", "warning");
                    isValidated = false;
                    return;
                }

                if (element.TypeLoad == null) {
                    this.$fun.alert("Necesita especificar tipo de carga", "warning");
                    isValidated = false;
                    return;
                }

                /* if ((element.TptNumberReferralGuide.length == 0 || element.TptNumberReferralGuide == null) && element.TypeLoad == 2) {
                    this.$fun.alert("Especifique Guia de Remision para Vehiculos de Materiales de Capataz: " + element.TptFrmName, "warning");
                    isValidated = false;
                    return;
                  } */
            });

            return isValidated;
        },

        isValidatedDocuments(val) {
            let isValidated = true;
            if (val.RcsNumberHarvestGuide == null || val.RcsNumberHarvestGuide == "") {
                this.$fun.alert("Ingrese Numero Guia de Cosecha", "warning");
                isValidated = false;
                return;
            }

            if (val.RcsNumberReferralGuide == null || val.RcsNumberReferralGuide == "") {
                this.$fun.alert("Ingrese Guia de Remision", "warning");
                isValidated = false;
                return;
            }

            if (val.RcsSunshineSeal == null || val.RcsSunshineSeal == "") {
                this.$fun.alert("Ingrese Precinto Sunshine", "warning");
                isValidated = false;
                return;
            }

            return isValidated;
        },

        isValidatedHeader(val) {
            let isValidated = true;

            if (val.HvsID == 0) {
                this.$fun.alert("No se ha seleccionado registro", "warning");
                isValidated = false;
                return;
            }

            if (this.objLot.PrdText == null || this.objLot.PrdText == undefined) {
                this.$fun.alert("No se ha seleccionado Productor", "warning");
                isValidated = false;
                return;
            }

            if (this.objLot.FagName == null || this.objLot.FagName == undefined) {
                this.$fun.alert("No se ha seleccionado Fundo", "warning");
                isValidated = false;
                return;
            }

            if (this.objLot.FltName == null || this.objLot.FltName == undefined) {
                this.$fun.alert("No se ha seleccionado Lote", "warning");
                isValidated = false;
                return;
            }

            if (
                this.objLot.TypeCultive == undefined ||
                this.objLot.TypeCultive == null
            ) {
                this.$fun.alert("No se ha seleccionado Cultivo", "warning");
                isValidated = false;
                return;
            }

            if (this.objLot.TypeCrop == undefined || this.objLot.TypeCrop == null) {
                this.$fun.alert("No se ha seleccionado Tipo Cultivo", "warning");
                isValidated = false;
                return;
            }

            return isValidated;
        },

        async save(val) {
            if (!this.isValidatedHeader(val)) {
                return;
            }
            if (!this.isValidatedForeman()) {
                return;
            }
            if (!this.isValidatedVehicle()) {
                return;
            }
            if (!this.isValidatedDocuments(val)) {
                return;
            }

            for (const plate of this.uniquePlates) {
                const itemsForPlate = this.itemsGang.filter(i => i.VehPlate === plate);
                const sumJabasReales = itemsForPlate.reduce((sum, item) => sum + (Number(item.FrmQuantityReal) || 0), 0);

                if (sumJabasReales > 0) {
                    const hasPdfFruta = this.AttachPDF[plate] || this.getExistingPath(plate, 'TasPathGngGuideTransportPdf');
                    const hasXmlFruta = this.AttachXML[plate] || this.getExistingPath(plate, 'TasPathGngGuideTransportXml');

                    const hasPdfMaterial = this.AttachPDFMaterials[plate] || this.getExistingPath(plate, 'TasPathGngGuideTransportMaterialsPdf');
                    const hasXmlMaterial = this.AttachXMLMaterials[plate] || this.getExistingPath(plate, 'TasPathGngGuideTransportMaterialsXml');

                    // if (!hasPdfFruta || !hasXmlFruta) {
                    //     this.$fun.alert(`Debe adjuntar la Guía Remisión Transportista (PDF y XML) de Fruta para la placa ${plate} ya que cuenta con jabas cosechadas.`, "warning");
                    //     return;
                    // }
                    // if (!hasPdfMaterial || !hasXmlMaterial) {
                    //     this.$fun.alert(`Debe adjuntar la Guía Remisión Transportista (PDF y XML) de Materiales para la placa ${plate} ya que cuenta con jabas cosechadas.`, "warning");
                    //     return;
                    // }
                }

                if (this.AttachPDF[plate] && this.AttachPDF[plate].type != "application/pdf") {
                    this.$fun.alert(`Archivo no permitido en Guia Remision Transportista para placa ${plate} (sólo PDF)`, "warning");
                    return;
                }
                if (this.AttachXML[plate] && this.AttachXML[plate].type != "text/xml") {
                    this.$fun.alert(`Archivo no permitido en Guia Remision Transportista para placa ${plate} (sólo XML)`, "warning");
                    return;
                }
                if (this.AttachPDFMaterials[plate] && this.AttachPDFMaterials[plate].type != "application/pdf") {
                    this.$fun.alert(`Archivo no permitido en Guia Remision Transportista Materiales para placa ${plate} (sólo PDF)`, "warning");
                    return;
                }
                if (this.AttachXMLMaterials[plate] && this.AttachXMLMaterials[plate].type != "text/xml") {
                    this.$fun.alert(`Archivo no permitido en Guia Remision Transportista Materiales para placa ${plate} (sólo XML)`, "warning");
                    return;
                }
            }


            this.xCount = 0;
            val.SecStatus = 1;
            val.UsrCreateID = this.$fun.getUserID(); //Obtenemos el ID del Usuario
            val.RcsState = 1;
            val.RcsDateReception = this.$fun.getDate(0);

            val.PrdID = this.objLot.PrdID;
            val.FagID = this.objLot.FagID;
            val.FltID = this.objLot.FltID;

            val.TypeCrop = this.objLot.TypeCrop;
            val.TypeCultive = this.objLot.TypeCultive;
            val.VrtID = this.objLot.VrtID;
            val.TypeNegociation = this.objLot.TypeNegociation;
            val.RcsPaymentZone = this.RcsPaymentZone;

            //Verificamos que Planta Procesadora es Sunshine, Establecemos Empacadora en NULL
            if (val.TypeProcessingPlant == 1) {
                val.TypeBaler = null;
            }

            //Agregamos el RcsID a Capataces
            this.itemsGang.forEach((element) => {
                element.RcsID = val.RcsID;
                element.SecStatus = 1;
                element.UsrCreateID = this.$fun.getUserID();
            });

            //Agregamos el RcsID a Vehiculos
            this.itemsVehicle.forEach((element) => {
                element.RcsID = val.RcsID;
                element.SecStatus = 1;
                element.UsrCreateID = this.$fun.getUserID();

                if (element.TypeLoad == 1) {
                    this.xCount = this.xCount + 1;
                }
            });

            val.itemsGang = this.itemsGang;
            val.itemsVehicle = this.itemsVehicle;

            if (this.xCount > 1) {
                this.$fun.alert("Error... La Programacion de Cosecha solo puede tener 01 vehiculo para transporte de Fruta", "warning");
                return;
            }

            if (this.xCount == 0) {
                this.$fun.alert("Error... La Programacion de Cosecha no contiene vehiculo para transporte de Fruta", "warning");
                return;
            }

            const loadFileOnServer = async (model, fileName, paramRoute = "RutaAnexosSAP", overwrite = true) => {
                try {
                    const response = await _GenUploadFiles.upload(model, fileName.toUpperCase(), paramRoute, overwrite);
                    // console.log({ response })
                    if (response.status == 200) {
                        return {
                            success: true,
                            message: response.data.message,
                            path: response.data.path,
                            fileName: response.data.fileName,
                        }
                    } else {
                        return {
                            success: false,
                            message: 'Error al subir archivo',
                        }
                    }
                } catch (error) {
                    console.log("Error on loadFileOnServer: ", error);
                    return {
                        success: false,
                        message: error.message,
                    }
                }
            }

            // console.log("Guardar", JSON.parse(JSON.stringify(val)));

            this.$fun.alert("Seguro de Guardar?", "question").then(async (r) => {
                if (r.value) {
                    this.processing = true;

                    for (const plate of this.uniquePlates) {
                        const plateItem = this.itemsGang.find(i => i.VehPlate == plate) || {};

                        if (this.AttachPDF[plate]) {
                            const sum = this.XMLSummary[plate]?.fruta || {};
                            const ruc = plateItem.rucEmisor || sum.rucEmisor;
                            const tipo = plateItem.tipoDoc || sum.tipoDoc;
                            const nro = sum.nroGuia;
                            const fileNamePDF = (ruc && tipo && nro) ? `${ruc}-${tipo}-${nro}` : (nro ? nro : this.AttachPDF[plate].name.split('.').slice(0, -1).join('.'));

                            const uploadedPDF = await loadFileOnServer(this.AttachPDF[plate], fileNamePDF);
                            if (uploadedPDF.success) {
                                this.itemsGang.forEach(item => {
                                    if (item.VehPlate == plate) item.TasPathGngGuideTransportPdf = uploadedPDF.fileName;
                                });
                            } else {
                                this.$fun.alert("Error al subir PDF GRE para placa " + plate + ", " + uploadedPDF.message, "error");
                            }
                        }

                        if (this.AttachXML[plate]) {
                            const sum = this.XMLSummary[plate]?.fruta || {};
                            const ruc = plateItem.rucEmisor || sum.rucEmisor;
                            const tipo = plateItem.tipoDoc || sum.tipoDoc;
                            const nro = sum.nroGuia;
                            const fileNameXML = (ruc && tipo && nro) ? `${ruc}-${tipo}-${nro}` : (nro ? nro : this.AttachXML[plate].name.split('.').slice(0, -1).join('.'));

                            const uploadedXML = await loadFileOnServer(this.AttachXML[plate], fileNameXML);
                            if (uploadedXML.success) {
                                this.itemsGang.forEach(item => {
                                    if (item.VehPlate == plate) item.TasPathGngGuideTransportXml = uploadedXML.fileName;
                                });
                            } else {
                                this.$fun.alert("Error al subir XML GRE para placa " + plate + ", " + uploadedXML.message, "error");
                            }
                        }

                        if (this.AttachPDFMaterials[plate]) {
                            const sum = this.XMLSummary[plate]?.materiales || {};
                            const ruc = plateItem.rucEmisorMaterials || sum.rucEmisor;
                            const tipo = plateItem.tipoDocMaterials || sum.tipoDoc;
                            const nro = sum.nroGuia;
                            const fileNamePDFMaterial = (ruc && tipo && nro) ? `${ruc}-${tipo}-${nro}` : (nro ? nro : this.AttachPDFMaterials[plate].name.split('.').slice(0, -1).join('.'));

                            const uploadedMatPDF = await loadFileOnServer(this.AttachPDFMaterials[plate], fileNamePDFMaterial);
                            if (uploadedMatPDF.success) {
                                this.itemsGang.forEach(item => {
                                    if (item.VehPlate == plate) item.TasPathGngGuideTransportMaterialsPdf = uploadedMatPDF.fileName;
                                });
                            } else {
                                this.$fun.alert("Error al subir PDF GRE Materiales para placa " + plate + ", " + uploadedMatPDF.message, "error");
                            }
                        }

                        if (this.AttachXMLMaterials[plate]) {
                            const sum = this.XMLSummary[plate]?.materiales || {};
                            const ruc = plateItem.rucEmisorMaterials || sum.rucEmisor;
                            const tipo = plateItem.tipoDocMaterials || sum.tipoDoc;
                            const nro = sum.nroGuia;
                            const fileNameXMLMaterial = (ruc && tipo && nro) ? `${ruc}-${tipo}-${nro}` : (nro ? nro : this.AttachXMLMaterials[plate].name.split('.').slice(0, -1).join('.'));

                            const uploadedMatXML = await loadFileOnServer(this.AttachXMLMaterials[plate], fileNameXMLMaterial);
                            if (uploadedMatXML.success) {
                                this.itemsGang.forEach(item => {
                                    if (item.VehPlate == plate) item.TasPathGngGuideTransportMaterialsXml = uploadedMatXML.fileName;
                                });
                            } else {
                                this.$fun.alert("Error al subir XML GRE Materiales para placa " + plate + ", " + uploadedMatXML.message, "error");
                            }
                        }
                    }

                    val.GetGang = this.itemsGang;
                    console.log("Guardar", JSON.parse(JSON.stringify({ val })));

                    _sReceptionSurveillance.save(val, this.$fun.getUserID()).then(
                        (resp) => {
                            if (resp.status == 200) {
                                this.processing = false;
                                this.AttachPDF = {};
                                this.AttachXML = {};
                                this.AttachPDFMaterials = {};
                                this.AttachXMLMaterials = {};
                                this.XMLSummaryFruta = {};
                                this.XMLSummaryMaterials = {};
                                this.$fun.alert("Guardado Correctamente", "success");
                                this.$refs.gridReceptionSurveillance.refresh();
                            }
                        },
                        (e) => {
                            this.error = true;
                            this.messageProcessing = e.response.data.Message;
                            this.processing = true;
                        },
                    );
                }
            });

            //val.save();
        },

        editEvent() {
            if (this.existsData == false) {
                this.$fun.alert("No se ha seleccionado registro", "warning");
            }
        },

        searchSenasa(item) {
            //console.log("datos de busqueda", item);
            if (item) this.objLot = item;
            else this.objLot = {};
        },
        /* deleteTransportCap(){
            this.objTransport.NtpIDID = null
            this.objTransport.Driver = null
            this.objTransport.VehPlate = null
    
            this.selectedGang[0].VehPlate = null
            this.selectedGang[0].DriverName = null
            this.selectedGang[0].NtpIDDriver = null
    
          } */

        uploadFile() {
            var formData = new FormData();
            let i = 0;

            formData.append(i.toString(), this.Attach);
            i++;

            _sGeneral.uploadfile("123", this.$fun.getUserID(), formData, 3);
            this.$fun.alert("Guardado Correctamente", "success");
            this.$refs.gridReceptionSurveillance.refresh();
            this.$emit("onClose");
        },

        openFile(url) {
            //console.log("Nombre de url", url);
            _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
                //console.log("rtpa", r);
                this.$fun.download(r.data, url.name);
                // if(r.status === 200){

                // 	this.$fun.downloadHttp(r);
                // }
            });
        },

        saveFile() {
            //console.log("Nombre del Archivo: ", this.Attach);
            //console.log("Item:", this.selected);
            s_HarvestSchedule.uploadFileName(this.selected.HvsID, this.Attach.name, this.$fun.getUserID()).then((r) => {
                if (r.status === 200) {
                    console.log("Subido Correcto");
                    this.uploadFile();
                }
            });
        },

        openFileTransfer(fileName) {
            if (fileName) {
                _GenUploadFiles.getFile("PathDocumentCarrier", `${fileName}`)
                    .then((resp) => console.log("downloaded : ", resp))
                    .catch((error) => console.error("Error al obtener imagen:", error));
            }
        },

        getExistingPath(plate, keyFieldPath) {
            const gangItem = this.itemsGang.find(x => x.VehPlate == plate);
            if (gangItem && gangItem[keyFieldPath]) return gangItem[keyFieldPath];
        },

        getPlateSummary(plate) {
            if (!this.itemsGang) return '';
            const items = this.itemsGang.filter(i => i.VehPlate === plate);
            const prog = items.reduce((acc, curr) => acc + (Number(curr.FrmQuantityEstimate) || 0), 0);
            const real = items.reduce((acc, curr) => acc + (Number(curr.FrmQuantityReal) || 0), 0);
            return ` | JABAS PROG.: ${prog}`; //| JABAS REALES: ${real}
        },

        onPDFChange(e, plate) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.$set(this.AttachPDF, plate, files[0]);
        },

        async onXMLChange(e, plate) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            const file = files[0];
            const summary = await this.validateXMLPlate(file, plate);

            if (summary) {
                if (!this.XMLSummary[plate]) this.$set(this.XMLSummary, plate, {});
                this.$set(this.XMLSummary[plate], 'fruta', summary);
                if (summary.isValid) {
                    file.TasGngNumberGuideRemitente = summary.guiaRemitente;
                    file.NroGuiaXML = summary.nroGuia;
                    file.VehPlateXML = summary.placa;
                    this.$set(this.AttachXML, plate, file);
                    if (summary.guiaRemitente) {
                        this.itemsGang.forEach(item => {
                            if (item.VehPlate == plate) {
                                // this.$set(item, 'TasGngNumberGuideRemitente', summary.guiaRemitente); //Esto actualiza la GRE Fruta
                                this.$set(item, 'TasGngGuideTransport', summary.nroGuia);
                                this.$set(item, 'rucEmisor', summary.rucEmisor);
                                this.$set(item, 'tipoDoc', summary.tipoDoc);
                            }
                        });
                    }
                } else {
                    e.target.value = "";
                    this.$delete(this.AttachXML, plate);
                }
            }
        },

        onPDFMaterialsChange(e, plate) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.$set(this.AttachPDFMaterials, plate, files[0]);
        },

        async onXMLMaterialsChange(e, plate) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            const file = files[0];
            const summary = await this.validateXMLPlate(file, plate);

            if (summary) {
                if (!this.XMLSummary[plate]) this.$set(this.XMLSummary, plate, {});
                this.$set(this.XMLSummary[plate], 'materiales', summary);
                if (summary.isValid) {
                    file.TasGngNumberGuideMaterials = summary.guiaRemitente;
                    file.NroGuiaXML = summary.nroGuia;
                    file.VehPlateXML = summary.placa;
                    this.$set(this.AttachXMLMaterials, plate, file);
                    if (summary.guiaRemitente) {
                        this.itemsGang.forEach(item => {
                            if (item.VehPlate == plate) {
                                this.$set(item, 'TasGngNumberGuideMaterials', summary.guiaRemitente);
                                this.$set(item, 'TasGngGuideTransportMaterials', summary.nroGuia);
                                this.$set(item, 'rucEmisorMaterials', summary.rucEmisor);
                                this.$set(item, 'tipoDocMaterials', summary.tipoDoc);
                            }
                        });
                    }
                } else {
                    e.target.value = "";
                    this.$delete(this.AttachXMLMaterials, plate);
                }
            }
        },

        validateXMLPlate(file, expectedPlate) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(e.target.result, "text/xml");

                        const getTagValue = (parent, tag) => {
                            const node = parent.getElementsByTagName(tag)[0] || parent.getElementsByTagNameNS("*", tag)[0];
                            return node ? node.textContent.trim() : null;
                        };

                        // 1. nroGuia (ID principal)
                        let nroGuia = getTagValue(xmlDoc, "ID");

                        // 2. guiaRemitente (dentro de AdditionalDocumentReference con tipo 09)
                        let guiaRemitente = null;
                        const refs = xmlDoc.getElementsByTagNameNS("*", "AdditionalDocumentReference");
                        for (let i = 0; i < refs.length; i++) {
                            const typeCode = getTagValue(refs[i], "DocumentTypeCode");
                            if (typeCode === "09") {
                                guiaRemitente = getTagValue(refs[i], "ID");
                                break;
                            }
                        }

                        // 3. placa
                        let placa = getTagValue(xmlDoc, "LicensePlateID");
                        if (!placa) {
                            const transportEquip = xmlDoc.getElementsByTagNameNS("*", "TransportEquipment")[0];
                            if (transportEquip) {
                                placa = getTagValue(transportEquip, "ID");
                            }
                        }

                        // 4. rucEmisor (SchemeID 6)
                        let rucEmisor = null;
                        const supplier = xmlDoc.getElementsByTagNameNS("*", "DespatchSupplierParty")[0] ||
                            xmlDoc.getElementsByTagNameNS("*", "AccountingSupplierParty")[0];
                        if (supplier) {
                            const ids = supplier.getElementsByTagNameNS("*", "ID");
                            for (let j = 0; j < ids.length; j++) {
                                if (ids[j].getAttribute("schemeID") === "6") {
                                    rucEmisor = ids[j].textContent.trim();
                                    break;
                                }
                            }
                        }

                        // 5. tipoDoc
                        let tipoDoc = getTagValue(xmlDoc, "DocumentTypeCode") || getTagValue(xmlDoc, "InvoiceTypeCode");
                        if (!tipoDoc && xmlDoc.documentElement.nodeName.includes("DespatchAdvice")) {
                            tipoDoc = "31";
                        }

                        const formattedPlaca = placa ? placa.replace(/-/g, '').trim().toUpperCase() : null;
                        const formattedExpected = expectedPlate.replace(/-/g, '').trim().toUpperCase();

                        const isValid = formattedPlaca === formattedExpected;

                        if (!isValid) {
                            if (!placa) {
                                this.$fun.alert("No se encontró la placa en la estructura del XML.", "warning");
                            } else {
                                this.$fun.alert(`La placa del XML (${placa || 'No Encontrada'}) no coincide con la placa asignada (${expectedPlate}).`, "warning");
                            }
                        }

                        resolve({ isValid, nroGuia, guiaRemitente, placa, expectedPlate, rucEmisor, tipoDoc });
                    } catch (err) {
                        console.error("Error parsing XML:", err);
                        this.$fun.alert("Error al procesar la estructura del XML.", "error");
                        resolve(null);
                    }
                };
                reader.onerror = () => {
                    this.$fun.alert("Error al leer el archivo XML.", "error");
                    resolve(null);
                };
                reader.readAsText(file);
            });
        },

        clearPDF(plate, index) {
            if (this.AttachPDF[plate]) {
                this.$delete(this.AttachPDF, plate);
                if (this.$refs.fileInputPDF && this.$refs.fileInputPDF[index]) {
                    this.$refs.fileInputPDF[index].value = "";
                }
            }
            this.itemsGang.forEach(item => {
                if (item.VehPlate === plate) {
                    this.$set(item, 'TasPathGngGuideTransportPdf', null);
                    this.$set(item, '_pdfCleared', true);
                }
            });
        },

        clearXML(plate, index) {
            if (this.AttachXML[plate]) {
                this.$delete(this.AttachXML, plate);
                if (this.$refs.fileInputXML && this.$refs.fileInputXML[index]) {
                    this.$refs.fileInputXML[index].value = "";
                }
            }
            this.itemsGang.forEach(item => {
                if (item.VehPlate == plate) {
                    // this.$set(item, 'TasGngNumberGuideRemitente', null);
                    this.$set(item, 'TasPathGngGuideTransportXml', null);
                    this.$set(item, 'TasGngGuideTransport', null);
                    this.$set(item, '_xmlCleared', true);
                }
            });

            if (this.XMLSummary[plate]) {
                this.$delete(this.XMLSummary[plate], 'fruta');
                if (!this.XMLSummary[plate].fruta && !this.XMLSummary[plate].materiales) {
                    this.$delete(this.XMLSummary, plate);
                }
            }
        },

        clearPDFMaterials(plate, index) {
            if (this.AttachPDFMaterials[plate]) {
                this.$delete(this.AttachPDFMaterials, plate);
                if (this.$refs.fileInputPDFMaterials && this.$refs.fileInputPDFMaterials[index]) {
                    this.$refs.fileInputPDFMaterials[index].value = "";
                }
            }
            this.itemsGang.forEach(item => {
                if (item.VehPlate == plate) {
                    this.$set(item, 'TasPathGngGuideTransportMaterialsPdf', null);
                    this.$set(item, '_pdfMatCleared', true);
                }
            });
        },

        clearXMLMaterials(plate, index) {
            if (this.AttachXMLMaterials[plate]) {
                this.$delete(this.AttachXMLMaterials, plate);
                if (this.$refs.fileInputXMLMaterials && this.$refs.fileInputXMLMaterials[index]) {
                    this.$refs.fileInputXMLMaterials[index].value = "";
                }
            }
            this.itemsGang.forEach(item => {
                if (item.VehPlate == plate) {
                    this.$set(item, 'TasPathGngGuideTransportMaterialsXml', null);
                    this.$set(item, 'TasGngGuideTransportMaterials', null);
                    this.$set(item, '_xmlMatCleared', true);
                }
            });

            if (this.XMLSummary[plate]) {
                this.$delete(this.XMLSummary[plate], 'materiales');
                if (!this.XMLSummary[plate].fruta && !this.XMLSummary[plate].materiales) {
                    this.$delete(this.XMLSummary, plate);
                }
            }
        },

        changeGuideRemission(value) {
            if (this.itemsGang.length == 0) return;
            this.itemsGang.forEach(item => {
                this.$set(item, 'TasGngNumberGuideRemitente', value);
            });
        },

        async clickTransfer(val) {
            this.messageValidation = null;
            this.selected = Object.keys(val).length > 0 ? val : { SecStatus: 1 };

            if (this.selected.HvsID) {
                this.isLoading = true;
                try {
                    const [rGang, rTrans] = await Promise.all([
                        _sReceptionSurveillance.GetGang(
                            { HvsID: this.selected.HvsID },
                            this.$fun.getUserID(),
                        ),
                        _sReceptionSurveillance.GetTransport(
                            { HvsID: this.selected.HvsID },
                            this.$fun.getUserID(),
                        ),
                    ]);
                    if (rGang.data.length > 0)
                        this.$set(this.selected, "GetGang", rGang.data);
                    if (rTrans.data.length > 0)
                        this.$set(this.selected, "GetTransport", rTrans.data);
                } catch (e) {
                    console.error(e);
                } finally {
                    this.isLoading = false;
                }
            }
            console.log({ selectedTransfer: this.selected });
            this.filterTransfer.HvsID = val.HvsID;
            this.dialogTransfer = true;
        },

        getSumatoriaJabas(key = "FrmQuantityReal") {
            return this.selected.GetGang.reduce(
                (sum, item) => sum + (item[key] || 0),
                0,
            );
        },

        dblclick(event) {
            if (event !== null && event.item) {
                console.log(event?.item);
                this.formTransfer.VehPlate = event.item.VehPlate;
                this.formTransfer.TrtDriverID = event.item.NtpIDDriver;
                this.formTransfer.CfvCapacity = event.item.CfvCapacity;
                this.formTransfer.TrtDriverName = event.item.Driver;
                this.formTransfer.TypeVehicleName = event.item.TypeVehicleText;
            } else {
                this.formTransfer.VehPlate = null;
                this.formTransfer.TrtDriverID = null;
                this.formTransfer.CfvCapacity = 0;
                this.formTransfer.TrtDriverName = null;
                this.formTransfer.TypeVehicleName = null;
            }
            console.log(this.formTransfer);
            this.messageValidation =
                this.formTransfer.CfvCapacity >= this.selected.GetTransport.TptTon
                    ? "EL tonelaje del vehiculo de transbordo debe ser menor al tonelaje del transporte programado"
                    : null;
        },
        async saveTransfer(event) {
            this.formTransfer.HvsID = this.selected.HvsID;
            this.formTransfer.UsrCreateID = this.$fun.getUserID();
            if (!this.formTransfer.HvsID) {
                this.$fun.alert(
                    "No se ha vinculado la programación de cosecha",
                    "warning",
                );
                return;
            }

            if (!this.formTransfer.FrmID) {
                this.$fun.alert("Seleccionar el capataz", "warning");
                return;
            }

            if (!this.formTransfer.VehPlate) {
                this.$fun.alert("Seleccionar vehículo", "warning");
                return;
            }

            if (!this.formTransfer.TrtDriverID) {
                this.$fun.alert("Seleccionar conductor", "warning");
                return;
            }

            if (!this.formTransfer.TransferQuantity) {
                this.$fun.alert("Ingresar cantidad a transbordar", "warning");
                return;
            }

            if (this.AttachTransfer) {
                try {
                    const response = await _GenUploadFiles.upload(
                        this.AttachTransfer,
                        `Trt${this.formTransfer.HvsID}_${Date.now()}`,
                        "PathDocumentCarrier",
                        true,
                    );
                    this.formTransfer.UploadFile =
                        response.status == 200 ? response.data.fileName : null;
                } catch (error) {
                    console.log("Error al subir archivo", error);
                    this.$fun.alert("Error al subir el archivo", "error");
                    return;
                }
            }

            _sReceptionTransfer
                .save(this.formTransfer, this.$fun.getUserID())
                .then((res) => {
                    if (res.status === 200) {
                        this.$fun.alert("Guardado Correctamente", "success");
                        this.$refs.gridReceptionTransfer.refresh();
                        this.clearFormTransfer();
                    }
                });
        },

        rowSelectedTransfer(item) {
            // console.log({ item })
            if (item.length > 0) {
                this.formTransfer = { ...item[0] };
            }
            // this.formTransfer = item.length > 0 ? { ...item[0] } : { SecStatus: 1 }
        },
        editTransfer() {
            // console.log("editTransfer", this.formTransfer)
            if (this.formTransfer.VehPlate) {
            }
        },
        clearFormTransfer() {
            this.AttachTransfer = null;
            this.formTransfer = {
                TrtID: 0,
                HvsID: null,
                VehPlate: null,
                TrtDriverID: null,
                TrtDriverName: null,
                CfvCapacity: 0,
                TypeVehicleName: null,
                UploadFile: null,
                SecStatus: 1,
                TransferDate: null,
            };
        },

        changeZonePayment: (event) => {
            // console.log(event)
        },
        getZonesGroup() {
            const parameters = { TypeZon: this.selected ? this.selected?.TypeZon || 0 : 0 }
            _sTasGroupZonService.GetZonesByGroup(parameters, this.$fun.getUserID()).then((response) => {
                this.ZonesGroup = response.status == 200 ? response.data : [];
                if (this.selected) {
                    this.RcsPaymentZone = this.selected?.RcsPaymentZone || this.selected?.ZonID;
                }
            });
        },
        downloadFileGRE(fileName) {
            console.log(fileName)
            if (fileName) {
                _GenUploadFiles.getFile("RutaAnexosSAP", fileName)
                    .then((resp) => console.log("downloaded : ", resp))
                    .catch((error) => console.error("Error al descargar fileName:", error));
            }
        },
        openHarvestersModal(item) {
            this.currentForemanForModal = item;
            this.showHarvestersModal = true;
            console.log("item", item)
        },
    },
};
</script>
<style scoped>
.modern-header {
    background: linear-gradient(135deg, #606060 0%, #525c64 100%);
    padding: 12px;
    color: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-actions {
    display: flex;
    align-items: end;
    gap: 8px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    background: rgba(255, 255, 255, 0.2);
    padding: 8px;
    border-radius: 12px;
    backdrop-filter: blur(10px);
}

.header-text,
.header-title {
    flex: 1;
}

.clear-btn,
.close-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
}

.clear-btn:hover,
.close-btn:hover {
    background: rgba(255, 255, 255, 0.25) !important;
    transform: scale(1.05);
}

.shadow-premium {
    box-shadow: 0 5px 10px -3px rgba(0, 0, 0, 0.1),
        0 2px 4px -2px rgba(0, 0, 0, 0.05) !important;
    transition: transform 0.2s ease-in-out;
}

.shadow-premium:hover {
    transform: translateY(-2px);
}

.premium-file-card {
    border: 2px dashed #e0e0e0 !important;
    background-color: #fafafa !important;
    border-radius: 12px !important;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 52px;
    display: flex;
    align-items: center;
}

.premium-file-card:hover {
    border-color: #1976d2 !important;
    border-style: solid !important;
    background-color: #f5f9ff !important;
}

.premium-file-card.active {
    border: 2px solid #ffcdd2 !important;
    background-color: #fff9f9 !important;
}

.premium-file-card.active-xml {
    border: 2px solid #c8e6c9 !important;
    background-color: #f9fff9 !important;
}

.file-icon-container {
    min-width: 38px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eeeeee;
    transition: all 0.4s ease;
}

.pdf-active {
    background: linear-gradient(135deg, #ff5252 0%, #d32f2f 100%);
    box-shadow: 0 4px 10px rgba(211, 47, 47, 0.3);
}

.xml-active {
    background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%);
    box-shadow: 0 4px 10px rgba(46, 125, 50, 0.3);
}

.file-name {
    font-size: 0.75rem;
    font-weight: 700;
    color: #2c3e50;
    max-width: 100%;
}

.file-placeholder {
    font-size: 0.7rem;
    color: #9e9e9e;
    font-weight: 500;
}

.group-wrapper {
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 8px 10px;
    height: 100%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transition: all 0.3s ease;
    margin-top: 4px;
}

.group-wrapper:hover {
    border-color: #bdbdbd;
    background: #fafdff;
}

.group-wrapper.materiales {
    background: #fcfcfc;
}

.group-header {
    font-weight: 800;
    font-size: 0.65rem;
    color: #455a64;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.border-light {
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

/* QR Scanner Styling */
.qr-dropzone {
    border: 2px dashed #cfd8dc;
    background-color: #f8fafc;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    height: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.qr-dropzone:hover,
.qr-dropzone.drag-over {
    border-color: #1976d2 !important;
    background-color: #f0f7ff !important;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.1);
}

.qr-preview-container {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: 380px;
    background-color: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e2e8f0;
}

.qr-preview-image {
    max-height: 100%;
    max-width: 100%;
}

.scanner-laser {
    position: absolute;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, rgba(239, 68, 68, 0) 0%, rgba(239, 68, 68, 1) 50%, rgba(239, 68, 68, 0) 100%);
    box-shadow: 0 0 8px rgba(239, 68, 68, 0.8);
    animation: scanning 2s linear infinite;
    z-index: 2;
}

@keyframes scanning {
    0% {
        top: 0%;
    }

    50% {
        top: 100%;
    }

    100% {
        top: 0%;
    }
}

.bg-light-blue {
    background-color: #f0f9ff !important;
}

.border-dashed {
    border: 2px dashed #e2e8f0 !important;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: .5;
    }
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* QR Table Styling */
.qr-table-container {
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
}

.qr-table-scroll {
    max-height: 340px;
    overflow-y: auto;
}

.qr-data-table th {
    font-size: 0.72rem !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e2e8f0 !important;
}

.qr-data-table td {
    font-size: 0.75rem !important;
    border-bottom: 1px solid #f1f5f9 !important;
}

.qr-data-table tbody tr:hover {
    background-color: #f8fafc !important;
}

.text-selectable {
    user-select: text !important;
}
</style>
